<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <!--<div v-show="this.$route.path=='/M/ML'">-->
        <div v-if="bool_OutletAfterSave">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard>
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["MEM"]["NMAS"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="CloseOutletAfterSave()"><CIcon name=cilX></CIcon></CButton>
                                    </CCol>
                                </CRow>

                                <CRow class="mt-3">
                                    <CCol col="12">
                                        <p>{{this.getLanguage["MEM"]["U"]}}: {{ obj_member.U }}</p>
                                    </CCol>
                                    <CCol col="12">
                                        <p>{{this.getLanguage["MEM"]["UP"]}}:  {{ obj_member.UP }}</p>
                                    </CCol>
                                    <CCol col="12" v-if="str_afterSaveOutlet_URL">
                                        <p>{{this.getLanguage["WLBP"]["W"]}}:  {{str_afterSaveOutlet_URL}}</p>
                                    </CCol>
                                </CRow>

                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-info" size="sm" @click="copyMemberDetails()">
                                        {{this.getLanguage["BTN"]["C"]}}
                                    </CButton>
                                    <span class="SuccessMsg" v-if="bool_checkCopy"> {{this.getLanguage["BTN"]["CS"]}}</span>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_isMemberListAdvancedSearchModalVisible">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard>
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="8">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage['MEM']['ADBS']}}</h4>
                                    </CCol>
                                    <CCol col="4">
                                        <CButton id="btn-close1" class="float-right"
                                                 @click="showadvModals">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content" style="height:650px; overflow: hidden auto;">
                                    <CRow>
                                        <CCol>
                                            <p class="h6" style="margin-top:10px;">
                                                {{this.getLanguage['MEM']['MDTL']}}
                                            </p>
                                        </CCol>
                                    </CRow>
                                    <div class='subHeaderHR'></div>
                                    <CRow>
                                        <CCol col="3">
                                            <label class="col-form-label-sm">{{this.getLanguage['MEM']['B']}}</label>
                                            <date-range-picker :show-dropdowns="true"
                                                               opens="right"
                                                               :auto-apply="true"
                                                               v-model="searchBirthday"
                                                               @update="defaultDateRangePickerUpdateEvent"
                                                               :single-date-picker="true"
                                                               :ranges="false">
                                                <div slot="input" slot-scope="picker">
                                                    <div v-if="searchBirthday.startDate != ''">
                                                        <CInput size="sm"
                                                                :value="searchBirthday.startDate | moment('DD MMM YYYY')"
                                                                @change="DateTimeChange('BD',$event)" />
                                                    </div>
                                                    <div v-else>
                                                        <CInput size="sm"
                                                                @change="DateTimeChange('BD',$event)" />
                                                    </div>
                                                </div>
                                            </date-range-picker>
                                            <!--<date-range-picker :autoApply="true"
                                                               v-model="searchBirthday"
                                                               @update="defaultDateRangePickerUpdateEvent"
                                                               :single-date-picker="true"
                                                               :ranges="false"
                                                               opens="right">
                                                <div slot="input" slot-scope="picker">
                                                    <span v-if="picker.startDate!=null" style="padding: 8px;">{{ picker.startDate|moment("DD MMM YYYY")}}</span>
                                                </div>
                                            </date-range-picker>-->
                                            <CButton class="dr-clear" style="margin-left: -25px; float: right; position: relative; margin-top: 5px;" size="sm" @click="clearDateRangeFilter('searchBirthday')">
                                                <CIcon name="cilX" size="sm"></CIcon>
                                            </CButton>
                                        </CCol>

                                        <CCol col="3" size="sm" class="form-group">
                                            <label class="col-form-label-sm">{{this.getLanguage['MEM']['RS']}}</label>
                                            <treeselect :multiple="false"
                                                        :options="ddMemberStatusList"
                                                        :placeholder="this.utilGetDDLanguage('MEM.RS')"
                                                        v-model="searchMemberStatus" />
                                        </CCol>
                                        <CCol col="3">
                                            <label class='col-form-label-sm'>{{this.getLanguage['MT']['MTN']}}</label>
                                            <treeselect :multiple="false"
                                                        :options="ddTypeName"
                                                        v-model="searchTypeName"
                                                        :load-options="loadTypeNameOptions"
                                                        :placeholder="this.utilGetDDLanguage('MT.MTN')"
                                                        :cacheOptions="false"
                                                        :auto-load-root-options="false" />
                                        </CCol>
                                        <CCol col="3">
                                            <CInput size="sm"
                                                    :label="this.getLanguage['MEM']['RU']"
                                                    :value="searchReferralUN"
                                                    @change="v => searchReferralUN = v" />
                                        </CCol>
                                        <CCol col="3">
                                            <CInput size="sm"
                                                    :label="this.getLanguage['MEM']['RSN']"
                                                    :value="searchRegisterSourceName"
                                                    @change="v => searchRegisterSourceName = v" />
                                        </CCol>
                                        <CCol col="3">
                                            <CInput size="sm"
                                                    :label="this.getLanguage['MEM']['RC']"
                                                    :value="searchReferralCode"
                                                    @change="v => searchReferralCode = v" />
                                        </CCol>
                                        <CCol col="3" size="sm" class="form-group">
                                            <label class="col-form-label-sm">{{getLanguage['LOGRPT']['DEV']}} :</label>
                                            <treeselect :multiple="false"
                                                        :options="dd_deviceType"
                                                        :placeholder="this.utilGetDDLanguage('LOGRPT.DEV')"
                                                        v-model="searchDevice" />
                                        </CCol>
                                        <CCol col="3" size="sm" class="form-group">
                                            <label class="col-form-label-sm">{{this.getLanguage['MEM']['CBLN']}}</label>
                                            <treeselect :multiple="false"
                                                        :options="ddCreditBalanceList"
                                                        :placeholder="this.utilGetDDLanguage('MEM.CBLN')"
                                                        v-model="searchCreditBalance"
                                                        :load-options="loadCreditBalanceOptions"
                                                        :auto-load-root-options="false" />
                                        </CCol>

                                    </CRow>
                                    <CRow>
                                        <CCol col="3">
                                            <CInput size="sm"
                                                    :label="this.getLanguage['LOGRPT']['DO']"
                                                    :value="searchDomainName"
                                                    @change="v => searchDomainName = v" />
                                        </CCol>
                                        <CCol col="3" size="sm" class="form-group">
                                            <label class="col-form-label-sm">{{getLanguage['MEM']['TOM']}}</label>
                                            <treeselect :multiple="false"
                                                        :options="dd_typeofmember"
                                                        :placeholder="this.utilGetDDLanguage('MEM.TOM')"
                                                        v-model="searchTypeofmember" />
                                        </CCol>
                                        <CCol col="3" size="sm" class="form-group">
                                            <label class="col-form-label-sm">{{getLanguage['MEM']['LPSD']}}</label>
                                            <date-range-picker :show-dropdowns="true"
                                                               opens="left"
                                                               :auto-apply="true"
                                                               v-model="searchLPlayedDtRange"
                                                               @update="defaultDateRangePickerUpdateEvent"
                                                               :ranges="getDefaultDateRange()">
                                                <div slot="input" slot-scope="picker">
                                                    <div v-if="searchLPlayedDtRange.startDate != ''">
                                                        <CInput size="sm"
                                                                :value="searchLPlayedDtRange.startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                                @change="DateTimeChange('LPSD',$event)" />
                                                    </div>
                                                    <div v-else>
                                                        <CInput size="sm"
                                                                @change="DateTimeChange('LPSD',$event)" />
                                                    </div>
                                                </div>
                                            </date-range-picker>
                                            <CButton class="dr-clear" style="margin-left: -25px; float: right; position: relative; margin-top: 5px;" size="sm" @click="clearDateRangeFilter('searchLPlayedDtRange')">
                                                <CIcon name="cilX" size="sm"></CIcon>
                                            </CButton>
                                        </CCol>
                                        <CCol col="3" size="sm" class="form-group">
                                            <label class="col-form-label-sm">{{getLanguage['MEM']['LPED']}}</label>
                                            <date-range-picker :show-dropdowns="true"
                                                               opens="left"
                                                               :auto-apply="true"
                                                               v-model="searchLPlayedDtRange"
                                                               @update="defaultDateRangePickerUpdateEvent"
                                                               :ranges="getDefaultDateRange()">
                                                <div slot="input" slot-scope="picker">
                                                    <div v-if="searchLPlayedDtRange.endDate != ''">
                                                        <CInput size="sm"
                                                                :value="searchLPlayedDtRange.endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                                @change="DateTimeChange('LPED',$event)" />
                                                    </div>
                                                    <div v-else>
                                                        <CInput size="sm"
                                                                @change="DateTimeChange('LPED',$event)" />
                                                    </div>
                                                </div>
                                            </date-range-picker>
                                            <CButton class="dr-clear" style="margin-left: -25px; float: right; position: relative; margin-top: 5px;" size="sm" @click="clearDateRangeFilter('searchLPlayedDtRange')">
                                                <CIcon name="cilX" size="sm"></CIcon>
                                            </CButton>
                                        </CCol>
                                    </CRow>

                                    <!-- <CRow>
                                        <CCol col="3" class="form-group">
                                            <label class="col-form-label-sm">{{this.getLanguage['MEM']['MRI']}}</label>
                                            <treeselect :multiple="false"
                                                        :options="ddMemberRankList"
                                                        :load-options="loadMemberRankOptions"
                                                        :placeholder="this.utilGetDDLanguage('MEM.MRI')"
                                                        v-model="searchMemberRank"
                                                        :cacheOptions="false"
                                                        :auto-load-root-options="false" />
                                        </CCol>
                                    </CRow> -->

                                    <CRow>
                                        <CCol>
                                            <p class="h6" style="margin-top:10px;">
                                                {{this.getLanguage['MEM']['CD']}}
                                            </p>
                                        </CCol>
                                    </CRow>
                                    <div class='subHeaderHR'></div>
                                    <CRow>
                                        <CCol col="3">
                                            <CInput size="sm"
                                                    :label="this.getLanguage['MEM']['PN']"
                                                    :value="searchPhone"
                                                    @change="v => searchPhone = v" />
                                        </CCol>

                                        <CCol col="3">
                                            <CInput size="sm"
                                                    :label="this.getLanguage['MEM']['E']"
                                                    :value="searchEmail"
                                                    @change="v => searchEmail = v" />
                                        </CCol>

                                        <CCol col="3">
                                            <CInput size="sm"
                                                    :label="this.getLanguage['MEM']['WC']"
                                                    :value="searchWeChat"
                                                    @change="v => searchWeChat = v" />
                                        </CCol>

                                        <CCol col="3">
                                            <CInput size="sm"
                                                    :label="this.getLanguage['MEM']['LID']"
                                                    :value="searchLine"
                                                    @change="v => searchLine = v" />
                                        </CCol>
                                    </CRow>

                                    <CRow>
                                        <CCol>
                                            <p class="h6" style="margin-top:10px;">
                                                {{this.getLanguage['MEM']['BAD']}}
                                            </p>
                                        </CCol>
                                    </CRow>
                                    <div class='subHeaderHR'></div>
                                    <CRow>
                                        <CCol col="3" size="sm" class="form-group">
                                            <label class="col-form-label-sm">{{this.getLanguage['MEM']['BI']}}</label>
                                            <treeselect :multiple="false"
                                                        :options="ddBankBrandList"
                                                        :placeholder="this.utilGetDDLanguage('MEM.BI')"
                                                        v-model="searchBank"
                                                        :load-options="loadBankBrandOptions"
                                                        :cacheOptions="false"
                                                        :auto-load-root-options="false" />
                                        </CCol>

                                        <CCol col="3">
                                            <CInput size="sm"
                                                    :label="this.getLanguage['MEM']['BA']"
                                                    :value="searchBankAccName"
                                                    @change="v => searchBankAccName = v" />
                                        </CCol>


                                    </CRow>

                                    <CRow>
                                        <CCol>
                                            <p class="h6" style="margin-top:10px;">
                                                {{this.getLanguage['MEM']['DD']}}
                                            </p>
                                        </CCol>
                                    </CRow>
                                    <div class='subHeaderHR'></div>
                                    <CRow>
                                        <CCol col="3" size="sm" class="form-group">
                                            <label class="col-form-label-sm">{{this.getLanguage['MEM']['DPST']}}</label>
                                            <treeselect :multiple="false"
                                                        :options="ddDepositedList"
                                                        :placeholder="this.utilGetDDLanguage('MEM.DPST')"
                                                        v-model="searchDeposited" />
                                        </CCol>

                                        <CCol col="3" size="sm" class="form-group">
                                            <label class="col-form-label-sm">{{this.getLanguage['MEM']['TD']}}</label>
                                            <treeselect :multiple="false"
                                                        :options="ddToDepositList"
                                                        :placeholder="this.utilGetDDLanguage('MEM.TD')"
                                                        v-model="searchToDeposit"
                                                        :load-options="loadTDepositOptions"
                                                        :auto-load-root-options="false" />
                                        </CCol>

                                        <CCol col="3">
                                            <label class="col-form-label-sm">{{this.getLanguage['MEM']['LDST']}} {{this.getLanguage['GL']['SD']}}</label>
                                            <date-range-picker :show-dropdowns="true"
                                                               opens="left"
                                                               :auto-apply="true"
                                                               v-model="searchLDepositDtRange"
                                                               @update="defaultDateRangePickerUpdateEvent"
                                                               :ranges="getDefaultDateRange()">
                                                <div slot="input" slot-scope="picker">
                                                    <div v-if="searchLDepositDtRange.startDate != ''">
                                                        <CInput size="sm"
                                                                :value="searchLDepositDtRange.startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                                @change="DateTimeChange('DSD',$event)" />
                                                    </div>
                                                    <div v-else>
                                                        <CInput size="sm"
                                                                @change="DateTimeChange('DSD',$event)" />
                                                    </div>
                                                </div>
                                            </date-range-picker>
                                            <CButton class="dr-clear" style="margin-left: -25px; float: right; position: relative; margin-top: 5px;" size="sm" @click="clearDateRangeFilter('searchLDepositDtRange')">
                                                <CIcon name="cilX" size="sm"></CIcon>
                                            </CButton>
                                        </CCol>

                                        <CCol col="3">
                                            <label class="col-form-label-sm">{{this.getLanguage['MEM']['LDST']}} {{this.getLanguage['GL']['ED']}}</label>
                                            <date-range-picker :show-dropdowns="true"
                                                               opens="left"
                                                               :auto-apply="true"
                                                               v-model="searchLDepositDtRange"
                                                               @update="defaultDateRangePickerUpdateEvent"
                                                               :ranges="getDefaultDateRange()">
                                                <div slot="input" slot-scope="picker">
                                                    <div v-if="searchLDepositDtRange.endDate != ''">
                                                        <CInput size="sm"
                                                                :value="searchLDepositDtRange.endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                                @change="DateTimeChange('DED',$event)" />
                                                    </div>
                                                    <div v-else>
                                                        <CInput size="sm"
                                                                @change="DateTimeChange('DED',$event)" />
                                                    </div>
                                                </div>
                                            </date-range-picker>
                                            <CButton class="dr-clear" style="margin-left: -25px; float: right; position: relative; margin-top: 5px;" size="sm" @click="clearDateRangeFilter('searchLDepositDtRange')">
                                                <CIcon name="cilX" size="sm"></CIcon>
                                            </CButton>
                                        </CCol>

                                    </CRow>
                                </div>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="success" size="sm" @click="getAdvancedMemberList()">
                                        <span class='searchIcon cil-search'></span>
                                        {{this.getLanguage["BTN"]["SR"]}}
                                    </CButton>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_isBAR">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["MTA"]["NAR"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="closeRequest()">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content dpt-wtd">
                                    <CRow>
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{this.getLanguage["MTA"]["BN"]}}<span class="required" /> :</label>
                                            <CInput :value="requestBrand" disabled size="sm" />
                                        </CCol>
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{this.getLanguage["MTA"]["MUN"]}} <span class="required" /> :</label>
                                            <CInput :value="requestUsername" disabled size="sm" />
                                        </CCol>
                                    </CRow>

                                    <CRow>
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{this.getLanguage["MTA"]["TT"]}} <span class="required" />: </label>
                                            <treeselect :multiple="false"
                                                        :options="dd_tranType"
                                                        v-model="obj_ad.TT" />
                                            <span class="ErrMsg">{{ ValidationAdjustmentErrMsg('TT','TT') }}</span>
                                        </CCol>
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{this.getLanguage["MTA"]["AA"]}}<span class="required" /> : <span class="amountNote" v-if="getThousandCurrency">{{getLanguage["GL"]["CUR"]}}</span></label>
                                            <CInput :prepend="CurrencySymbol" size="sm"
                                                    :value="ThousandSeparator(obj_ad.TA, getThousandCurrency ? 3 : 2)"
                                                    @change="v => obj_ad.TA = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)" />
                                            <span class="ErrMsg">{{ ValidationAdjustmentErrMsg('TA','TA') }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="12">
                                            <label class="col-form-label-sm">{{this.getLanguage["MTA"]["R"]}} <span class="required" />:</label>
                                            <textarea vertical="" rows="7" class="form-control form-control-sm" :value="obj_ad.R" @change="TextValueChange('RJ',$event)" />
                                            <span class="ErrMsg">{{ ValidationAdjustmentErrMsg('R','R') }}</span>
                                        </CCol>
                                    </CRow>
                                </div>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-info" size="sm" @click="saveRequest()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{this.getLanguage["BTN"]["SV"]}}
                                    </CButton>
                                </div>
                                <label class="mandatory_Field">{{this.getLanguage['MANDATORY']['FIELDS']}}</label>

                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_isDepositV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow" style="max-width:450px">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="12">
                                        <h3 id="traffic" class="card-title mb-0 text-center">{{this.getLanguage["MTA"]["CA"]}}</h3>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content dpt-wtd" style="overflow:unset">
                                    <CRow>
                                        <CCol col="12">
                                            <p class="font-weight-bold text-center">{{this.strTnxConfirm}}</p>
                                        </CCol>
                                    </CRow>
                                    <CRow v-if="!bool_isWithdraw">
                                        <div class="col-md-4">{{this.getLanguage["MEM"]["PROMO"]}} : </div>
                                        <div class="col-md-8">
                                            <treeselect :multiple="false"
                                                        :key="rtPromoKey"
                                                        :options="dd_promotion"
                                                        :auto-load-root-options="false"
                                                        :placeholder="getLanguage['MEM']['PROMO']"
                                                        class="inline"
                                                        v-model="obj_OutletTran['PI']" />
                                        </div>
                                    </CRow>
                                    <CRow v-if="!bool_isWithdraw" style="padding-top:5px;">
                                        <div class="col-md-4">{{this.getLanguage["MEM"]["UREC"]}} : </div>
                                        <div class="col-md-8">
                                            <div style="display:block;">
                                                <input type="file" name="pic" accept="image/*, .pdf" @change="onFileSelected" style="overflow: hidden;" />
                                            </div>
                                        </div>
                                    </CRow>
                                </div>

                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-info" size="sm" @click="closeDeposit()">
                                        <span class='xIcon cil-x'></span>
                                        {{this.getLanguage["GL"]["CANCEL"]}}
                                    </CButton>
                                    <CButton color="outline-info" size="sm" v-shortkey="['enter']" @shortkey="processTransaction()" @click="processTransaction()">
                                        <span class='checkIcon cil-check'></span>
                                        {{this.getLanguage["GL"]["CONFIRM"]}}
                                    </CButton>
                                </div>

                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_isTopup && isOUTMOB">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow" style="max-width:600px;"
                         role="dialog"
                         aria-labelledby="modalTitle"
                         aria-describedby="modalDescription">
                        <CCard style="height:100%;">
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{ getLanguage["SACH"]["TC"] }}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right"
                                                 @click="closeTopUp">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content" style="overflow:inherit;">
                                    <CRow>
                                        <CCol col="12" class="form-group">
                                            <label class="col-form-label-sm">{{this.getLanguage["MTA"]["TT"]}} :</label>
                                            <treeselect :multiple="false"
                                                        :options="dd_tranType"
                                                        v-model="obj_OutletTran2.TT" />
                                        </CCol>
                                    </CRow>
                                    <CRow v-if="obj_OutletTran2.TT == 1">
                                        <CCol col="12" class="form-group">
                                            <label class="col-form-label-sm">{{this.getLanguage["MEM"]["A"]}}</label>
                                            <CInput :placeholder="getLanguage['MEM']['A']"
                                                    size="sm"
                                                    :value="obj_OutletTran2.depositAmt"
                                                    @change="v => obj_OutletTran2.depositAmt = v"></CInput>
                                        </CCol>
                                    </CRow>
                                    <CRow v-if="obj_OutletTran2.TT == 2">
                                        <CCol col="12" class="form-group">
                                            <label class="col-form-label-sm">{{this.getLanguage["MEM"]["A"]}}</label>
                                            <CInput :placeholder="getLanguage['MEM']['A']"
                                                    size="sm"
                                                    :value="obj_OutletTran2.withdrawAmt"
                                                    @change="v => obj_OutletTran2.withdrawAmt = v"></CInput>
                                        </CCol>
                                    </CRow>
                                </div>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-info" size="sm" v-shortkey="['enter']" @shortkey="processTransaction()" @click="processTransaction()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{ getLanguage["AG"]["TUSB"] }}
                                    </CButton>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_fullPreview">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto" style="z-index: 1041;">
                    <div class="popupWindow">
                        <CCard>
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="8">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["GL"]["P"]}}</h4>
                                    </CCol>
                                    <CCol col="4">
                                        <CButton id="btn-close1" class="float-right" @click="closeAdd1">
                                            <CIcon name="cilX"></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content text-center">
                                    <img :src="previewUrl" class="img-fluid" v-if="previewUrl">
                                    <p v-else>{{this.getLanguage['GL']['NR']}}</p>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_isDDMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow" style="max-width: 450px;">
                        <CCard>
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["R"]["CSL"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="bool_isDDMV = false">
                                            <CIcon name="cilX"></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <div class="text-right">
                                        <CButton class="mb-1 btnReset" @click="resetColumn()" v-if="needResetHeaders">
                                            <span class="font-weight-bold cil-reload"></span>
                                            {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                                        </CButton>
                                    </div>

                                    <draggable v-model="reportHeaders" tag="ul" class="p-0 mb-0 sorttable">
                                        <li v-for="header in reportHeaders" :key="header" scope="col" class="list-group-item p-2">
                                            <template v-if="header == 'ACT' & (ML_E|| ML_D)">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["GL"]["ACT"]}}
                                            </template>
                                            <template v-else-if="header == 'NO'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage[["GL"]]["NO"]}}
                                            </template>
                                            <template v-else-if="header == 'AGT'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['GL']['AGT']}}
                                                <i @click="setSortTable('AGN')" :class="setSortLogo('AGN')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'ACC'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['MEM']['ACC']}}
                                                <i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'CIP'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['MEM']['CIP']}}
                                            </template>
                                            <template v-else-if="header == 'LFPI'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                <span style="color:#ff8c00;font-weight:700">{{getLanguage['MEM']['TSID']}}</span>/
                                                <span style="color:red;font-weight:900">{{getLanguage['MEM']['SU']}}</span>
                                            </template>
                                            <template v-else-if="header == 'LDTS'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['MEM']['LDTS']}}
                                            </template>
                                            <template v-else-if="header == 'PTTS'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['MEM']['PTTS']}}
                                            </template>
                                            <template v-else-if="header == 'LLTS_LLIP'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['MEM']['LLTS']}} / {{getLanguage['MEM']['LLIP']}}
                                                <i @click="setSortTable('LLTS')" :class="setSortLogo('LLTS')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'MEMMW'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['MEM']['MEMMW']}}
                                                <i @click="setSortTable('MEMMW')" :class="setSortLogo('MEMMW')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'MEMPW'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['MEM']['MEMPW']}}
                                                <i @click="setSortTable('MEMPW')" :class="setSortLogo('MEMPW')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'CBL'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['MEM']['CBL']}}
                                                <i @click="setSortTable('CBL')" :class="setSortLogo('CBL')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'D'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['DB']['D']}}
                                                <i @click="setSortTable('TD')" :class="setSortLogo('TD')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'TW'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['MEM']['TW']}}
                                                <i @click="setSortTable('TW')" :class="setSortLogo('TW')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'BA'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['MEM']['BA']}}
                                            </template>
                                            <template v-else-if="header == 'RSN'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['MEM']['RSN']}}
                                            </template>
                                            <template v-else-if="header == 'BR'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["MEM"]["BR"]}}
                                            </template>
                                            <template v-else-if="header == 'MRI'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['MEM']['MRI']}}
                                            </template>
                                            <template v-else-if="header == 'LLD'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['MEM']['LLD']}}
                                            </template>
                                            <template v-else-if="header == 'DEV'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['LOGRPT']['DEV']}}
                                                <i @click="setSortTable('IM')" :class="setSortLogo('IM')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'MKT'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['MEM']['MKT']}}
                                            </template>
                                            <template v-else-if="header == 'DA' && ML_E">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['MEM']['DA']}}
                                            </template>
                                            <template v-else-if="header == 'WA' && ML_E">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['MEM']['WA']}}
                                            </template>
                                            <template v-else-if="header == 'DLS' && ML_E">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['MEM']['DLS']}}
                                            </template>
                                            <template v-else-if="header == 'ARB' && ML_E">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['AG']['ARB']}}
                                            </template>
                                            <template v-else-if="header == 'AFF' && ML_E">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['AG']['AFF']}}
                                            </template>
                                            <template v-else-if="header == 'REWARD' && MAR_E">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['MEM']['REWARD']}}
                                            </template>
                                        </li>
                                    </draggable>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_isReward">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["MTA"]["AMR"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="closeReward()">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="dpt-wtd px-1">
                                    <CRow>
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{this.getLanguage["MTA"]["BN"]}}<span class="required" /> :</label>
                                            <CInput :value="obj_Reward.brand" disabled size="sm" />
                                        </CCol>
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{this.getLanguage["MTA"]["MUN"]}} <span class="required" /> :</label>
                                            <CInput :value="obj_Reward.username" disabled size="sm" />
                                        </CCol>
                                    </CRow>

                                    <CRow>
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{this.getLanguage["CR"]["C"]}} <span class="required" /> :</label>
                                            <CInput :value="obj_Reward.currency" disabled size="sm" />
                                        </CCol>
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{this.getLanguage["MEM"]["RWL"]}} <span class="required" />: </label>
                                            <treeselect :multiple="false"
                                                        :options="dd_RewardList"
                                                        v-model="obj_Reward.PRI" />
                                            <span class="ErrMsg">{{ ValidationRewardErrMsg('PRI','RWL') }}</span>
                                        </CCol>
                                    </CRow>
                                </div>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-info" size="sm" @click="saveManualReward()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{this.getLanguage["BTN"]["SV"]}}
                                    </CButton>
                                </div>
                                <label class="mandatory_Field">{{this.getLanguage['MANDATORY']['FIELDS']}}</label>

                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <!--  modal edit member, freeze, block, gamesetting -->
        <MemberCombineModal :editMemberInfo.sync="editMemberInfo" :editMemberBlock.sync="editMemberBlock" :editMemberFreeze.sync="editMemberFreeze" :editMemberGame.sync="editMemberGame" />

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{this.getLanguage['MEM']['ML']}}</h2>
                        <div class="d-flex flex-column flex-md-row align-items-end">
                            <CButton size="sm" v-if="ML_A" color="outline-info" @click="editMember(0)"><span class='plusIcon cil-plus'></span>{{this.getLanguage["BTN"]["AN"]}}</CButton>

                            <CButton size="sm" :color="`${bool_AdvancedFilterAvailable ? 'primary':'outline-primary' }`" @click="showadvModals()" v-if="!isOUTMOB"
                                     data-toggle="announcementAddmodal" data-target="#myModal">
                                <CIcon name="cilSettings" style="margin-right:3px" :style="`${bool_AdvancedFilterAvailable ? 'fill: #fff':'fill: #321fdb' }`"></CIcon>
                                {{this.getLanguage['MEM']['ADBS']}}

                                <div class="custom_tooltip" style="width: 20px; height: 17px;" @click.stop="clearAdvanceSearchFields" v-if="bool_AdvancedFilterAvailable">
                                    <i class="fa fa-check-circle text-success ml-2"></i>
                                    <span class="tooltiptext2" style=" left: auto; right: 0%; bottom: -130%; width: 150px;"> {{this.getLanguage['MEM']['CTCASF']}}</span>
                                </div>
                            </CButton>
                        </div>

                        <div class="custom_tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="tooltiptext tooltip-left" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="tooltiptext tooltip-left" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol' v-if="getUserInfo.AT !== 4">
                                <span class='searchLabel'>{{this.getLanguage['GL']['AGT']}} :</span>
                                <div class="inline">
                                    <div class="d-flex">
                                        <input type="checkbox" v-model="searchExcludeSubAgent" id="searchExcludeSubAgent" />
                                        <label class="searchLabel ml-1" for="searchExcludeSubAgent">{{getLanguage["GL"]["ODA"]}}</label>
                                    </div>
                                </div>
                                <customtreeselect :multiple="false"
                                                  :load-options="loadAgentOptions"
                                                  :options="ddAgentList"
                                                  :flat="true"
                                                  :defaultExpandLevel="Infinity"
                                                  :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                  v-model="selectedAgent"
                                                  @input="AgentGroupChangefs" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['SAGT']}} :</span>
                                <treeselect :multiple="false"
                                            :async="true"
                                            :key="rtSubBrand"
                                            :cacheOptions="false"
                                            :defaultOptions="ddDefaultSubBrand"
                                            :load-options="loadSubBrandOptions"
                                            :options="ddSubAgentList"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('GL.SAGT')"
                                            :noResultsText="this.getLanguage['GL']['NRF']"
                                            :disabled="searchExcludeSubAgent"
                                            v-model="searchSubAgent"
                                            @input="SubAgentGroupChangefs" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['MEM']['U']}} :</span>
                                <treeselect :multiple="false"
                                            :async="true"
                                            :cacheOptions="bool_cacheOptionValue"
                                            :load-options="loadMemberOptions"
                                            :options="ddMemberList"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('MEM.U')"
                                            v-model="searchUsername" />
                            </div>
                            <div class='searchCol' v-if="!isOUTMOB">
                                <span class="searchLabel">{{this.getLanguage['MEM']['RTS']}} {{this.getLanguage['GL']['SD']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="searchRegisterDtRange"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="searchRegisterDtRange.startDate != ''">
                                            <CInput size="sm"
                                                    :value="searchRegisterDtRange.startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('RSD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('RSD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter('searchRegisterDtRange')">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol' v-if="!isOUTMOB">
                                <span class="searchLabel">{{this.getLanguage['MEM']['RTS']}} {{this.getLanguage['GL']['ED']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="searchRegisterDtRange"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="searchRegisterDtRange.endDate != ''">
                                            <CInput size="sm"
                                                    :value="searchRegisterDtRange.endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('RED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('RED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter('searchRegisterDtRange')">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol' v-if="!isOUTMOB">
                                <span class='searchLabel'>{{this.getLanguage['MEM']['DN']}} :</span>
                                <CInput size="sm" :value="searchDisplayName" @change="v => searchDisplayName = v" />
                            </div>
                            <div class='searchCol' v-if="!isOUTMOB">
                                <span class='searchLabel'>{{this.getLanguage['MEM']['CIP']}} :</span>
                                <div class="inline">
                                    <div class="d-flex">
                                        <input type="checkbox" checked @click="registerIP()" id="searchExactRegIP" :value="searchExactRegIP" @change="v => searchExactRegIP = v" />
                                        <label class="searchLabel ml-1" for="searchExactRegIP">{{getLanguage["HELP"]["IPS"]}}</label>
                                    </div>
                                </div>
                                <CInput size="sm" :value="searchCIP" @change="v => searchCIP = v" />
                            </div>
                            <div class='searchCol' v-if="!isOUTMOB">
                                <span class='searchLabel'>{{this.getLanguage['MEM']['LLIP']}} :</span>
                                <div class="inline">
                                    <div class="d-flex">
                                        <input type="checkbox" checked @click="lastLoginIP()" id="searchExactLastLogInIP" :value="searchExactLastLogInIP" @change="v => searchExactLastLogInIP = v" />
                                        <label class="searchLabel ml-1" for="searchExactLastLogInIP">{{getLanguage["HELP"]["IPS"]}}</label>
                                    </div>
                                </div>
                                <CInput size="sm" :value="searchIP" @change="v => searchIP = v" />
                            </div>

                            <div class='searchCol' v-if="!isOUTMOB">
                                <span class='searchLabel'>{{this.getLanguage['MEM']['BAN']}} :</span>
                                <CInput size="sm" :value="searchBankAcc" @change="v => searchBankAcc = v" />
                            </div>
                            <div class='searchCol' v-if="!isOUTMOB">
                                <span class='searchLabel'>{{this.getLanguage['MEM']['MKT']}} :</span>
                                <treeselect :multiple="false"
                                            :async="true"
                                            :cacheOptions="bool_cacheMarketerOptionValue"
                                            :load-options="loadMarketerOptionsFS"
                                            :options="ddMarketerListFS"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('MEM.MKT')"
                                            v-model="searchMarketer" />
                            </div>
                            <div class='searchCol' v-if="!isOUTMOB">
                                <span class='searchLabel'>{{this.getLanguage["MEM"]["CI"]}} :</span>
                                <treeselect :multiple="false"
                                            :load-options="loadSearchMemberCurrencyOptions"
                                            :options="ddSearchMemberCurrencyList"
                                            :auto-load-root-options="false"
                                            :disable-branch-nodes="true"
                                            :placeholder="this.utilGetDDLanguage('MEM.CI')"
                                            v-model="searchCurrency" />
                            </div>
                            <div class='searchCol input-group' style="display: flex">
                                <!-- poker V member search -->
                                <span class='searchLabel'>
                                    {{this.getLanguage['MEM']['TWG']}} :
                                    <div class="custom_tooltip">
                                        <i class="fa fa-question-circle"></i>
                                        <span class="tooltiptext2" style=" width: 210px !important; left: -700% !important; margin-left: -800% !important;">{{getLanguage["HELP"]["TWG"]}}</span>
                                    </div>
                                </span>
                                <div class="col-sm-4" style="padding: 0px">
                                    <treeselect :multiple="false"
                                                :options="ddTransferWalletOptions"
                                                :clearable="false"
                                                :disable-branch-nodes="true"
                                                :placeholder="this.utilGetDDLanguage('MEM.TWG')"
                                                v-model="searchTWG" />
                                </div>
                                <div class="col-sm-8" style="padding: 0px">
                                    <CInput size="sm" :value="searchPKVU" @change="v => searchPKVU = v" />
                                </div>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MEM"]["MRK"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="ddSearchMemberRank"
                                            :auto-load-root-options="false"
                                            :disable-branch-nodes="true"
                                            :placeholder="this.utilGetDDLanguage('MEM.MRK')"
                                            v-model="searchMemberRank" />
                            </div>

                            <!--<div class='searchCol'>
                                <label class="searchLabel">{{//getLanguage['LOGRPT']['DEV']}} :</label>
                                <treeselect :multiple="false"
                                            :options="dd_deviceType"
                                            v-model="searchDevice" />
                            </div>-->
                        </div>
                        <div class=' searchBtnCol'>
                            <CButton v-shortkey="['enter']" ref="search" @shortkey="newSearch()" class='searchBtn' size="sm" block color="success" @click="newSearch()"><span class='searchIcon cil-search'></span><span>{{this.getLanguage['BTN']['SR']}}</span></CButton>
                        </div>
                    </div>

                </CCol>
            </CRow>

            <div class='table-wrapper'>
                <header class="table-header d-block d-md-flex">
                    <div class="d-md-flex align-items-center">
                        <strong>{{getLanguage['MEM']['ML']}}</strong>
                        <div class="ml-0 ml-md-2">
                            <span>
                                <span style="padding-right: 5px;">(<img src="../../../assets/icons/nerverwithdraw.svg" class="nwithdraw-icon" /> <strong style="font-size: 12px;">{{getLanguage["MTA"]["MNM"]}}</strong></span>
                                <span style="padding-right: 5px;"><img src="../../../assets/icons/newtransfer.svg" class="ntransfer-icon" /><strong class="ml-1" style="font-size: 12px;">{{getLanguage["MTA"]["PVP"]}}</strong></span>
                                <span><img src="../../../assets/icons/referral.svg" class="referral-icon" /><strong class="ml-1" style="font-size: 12px;">{{getLanguage["MTA"]["RFB"]}}</strong>)</span>
                            </span>
                        </div>
                    </div>
                    <div class="pageBtn">
                        <CButton class="btnReset" @click="bool_isDDMV = true"><span class="fa-solid fa-up-down"></span>{{this.getLanguage['R']['CS']}}</CButton>
                        <CButton class="btnReset" @click="resetColumn()" v-if="needResetHeaders">
                            <span class="font-weight-bold cil-reload"></span> {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                        </CButton>
                        <CButton v-if="checkModuleAccess('MEPE', 'M', constAccessType.edit)" class="btnExcel" @click="saveToExcel()">
                            <img src="/Content/img/excel.png" width="20" style="padding-left:2px">
                            {{this.getLanguage["BTN"]["DL"]}}
                        </CButton>
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue' id="example">
                        <thead>
                            <draggable v-model="reportHeaders" tag="tr">
                                <th v-for="header in reportHeaders" :key="header" scope="col" :class="renderClassName(header)">
                                    <template v-if="header == 'ACT' & (ML_E|| ML_D)">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["GL"]["ACT"]}}
                                    </template>
                                    <template v-else-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage[["GL"]]["NO"]}}
                                    </template>
                                    <template v-else-if="header == 'AGT'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['GL']['AGT']}}
                                        <i @click="setSortTable('AGN')" :class="setSortLogo('AGN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'ACC'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['ACC']}}
                                        <i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'CIP'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['CIP']}}
                                    </template>
                                    <template v-else-if="header == 'LFPI'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        <span style="color:#ff8c00;font-weight:700">{{getLanguage['MEM']['TSID']}}</span>/
                                        <span style="color:red;font-weight:900">{{getLanguage['MEM']['SU']}}</span>
                                    </template>
                                    <template v-else-if="header == 'LDTS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['LDTS']}}
                                    </template>
                                    <template v-else-if="header == 'PTTS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['PTTS']}}
                                    </template>
                                    <template v-else-if="header == 'LLTS_LLIP'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['LLTS']}} / {{getLanguage['MEM']['LLIP']}}
                                        <i @click="setSortTable('LLTS')" :class="setSortLogo('LLTS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'MEMMW'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['MEMMW']}}
                                        <i @click="setSortTable('MEMMW')" :class="setSortLogo('MEMMW')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'MEMPW'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['MEMPW']}}
                                        <i @click="setSortTable('MEMPW')" :class="setSortLogo('MEMPW')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'CBL'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['CBL']}}
                                        <i @click="setSortTable('CBL')" :class="setSortLogo('CBL')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'D'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['DB']['D']}}
                                        <i @click="setSortTable('TD')" :class="setSortLogo('TD')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'TW'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['TW']}}
                                        <i @click="setSortTable('TW')" :class="setSortLogo('TW')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'BA'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['BA']}}
                                    </template>
                                    <template v-else-if="header == 'RSN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['RSN']}}
                                    </template>
                                    <template v-else-if="header == 'BR'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["MEM"]["BR"]}}
                                    </template>
                                    <template v-else-if="header == 'MRI'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['MRI']}}
                                    </template>
                                    <template v-else-if="header == 'LLD'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['LLD']}}
                                    </template>
                                    <template v-else-if="header == 'DEV'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['LOGRPT']['DEV']}}
                                        <i @click="setSortTable('IM')" :class="setSortLogo('IM')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'MKT'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['MKT']}}
                                    </template>
                                    <template v-else-if="header == 'DA' && ML_E">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['DA']}}
                                    </template>
                                    <template v-else-if="header == 'WA' && ML_E">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['WA']}}
                                    </template>
                                    <template v-else-if="header == 'DLS' && ML_E">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['DLS']}}
                                    </template>
                                    <template v-else-if="header == 'ARB' && ML_E">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['AG']['ARB']}}
                                    </template>
                                    <template v-else-if="header == 'AFF' && ML_E">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['AG']['AFF']}}
                                    </template>
                                    <template v-else-if="header == 'REWARD' && MAR_E">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['REWARD']}}
                                    </template>
                                </th>
                            </draggable>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue' id="example">
                        <thead>
                            <draggable v-model="reportHeaders" tag="tr">
                                <th v-for="header in reportHeaders" :key="header" scope="col" :class="renderClassName(header)">
                                    <template v-if="header == 'ACT' & (ML_E|| ML_D)">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["GL"]["ACT"]}}
                                    </template>
                                    <template v-else-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage[["GL"]]["NO"]}}
                                    </template>
                                    <template v-else-if="header == 'AGT'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['GL']['AGT']}}
                                        <i @click="setSortTable('AGN')" :class="setSortLogo('AGN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'ACC'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['ACC']}}
                                        <i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'CIP'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['CIP']}}
                                    </template>
                                    <template v-else-if="header == 'LFPI'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        <span style="color:#ff8c00;font-weight:700">{{getLanguage['MEM']['TSID']}}</span>/
                                        <span style="color:red;font-weight:900">{{getLanguage['MEM']['SU']}}</span>
                                    </template>
                                    <template v-else-if="header == 'LDTS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['LDTS']}}
                                    </template>
                                    <template v-else-if="header == 'PTTS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['PTTS']}}
                                    </template>
                                    <template v-else-if="header == 'LLTS_LLIP'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['LLTS']}} / {{getLanguage['MEM']['LLIP']}}
                                        <i @click="setSortTable('LLTS')" :class="setSortLogo('LLTS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'MEMMW'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['MEMMW']}}
                                        <i @click="setSortTable('MEMMW')" :class="setSortLogo('MEMMW')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'MEMPW'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['MEMPW']}}
                                        <i @click="setSortTable('MEMPW')" :class="setSortLogo('MEMPW')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'CBL'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['CBL']}}
                                        <i @click="setSortTable('CBL')" :class="setSortLogo('CBL')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'D'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['DB']['D']}}
                                        <i @click="setSortTable('TD')" :class="setSortLogo('TD')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'TW'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['TW']}}
                                        <i @click="setSortTable('TW')" :class="setSortLogo('TW')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'BA'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['BA']}}
                                    </template>
                                    <template v-else-if="header == 'RSN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['RSN']}}
                                    </template>
                                    <template v-else-if="header == 'BR'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["MEM"]["BR"]}}
                                    </template>
                                    <template v-else-if="header == 'MRI'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['MRI']}}
                                    </template>
                                    <template v-else-if="header == 'LLD'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['LLD']}}
                                    </template>
                                    <template v-else-if="header == 'DEV'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['LOGRPT']['DEV']}}
                                        <i @click="setSortTable('IM')" :class="setSortLogo('IM')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'MKT'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['MKT']}}
                                    </template>
                                    <template v-else-if="header == 'DA' && ML_E">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['DA']}}
                                    </template>
                                    <template v-else-if="header == 'WA' && ML_E">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['WA']}}
                                    </template>
                                    <template v-else-if="header == 'DLS' && ML_E">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['DLS']}}
                                    </template>
                                    <template v-else-if="header == 'ARB' && ML_E">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['AG']['ARB']}}
                                    </template>
                                    <template v-else-if="header == 'AFF' && ML_E">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['AG']['AFF']}}
                                    </template>
                                    <template v-else-if="header == 'REWARD' && MAR_E">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['REWARD']}}
                                    </template>
                                </th>
                            </draggable>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if="!arr_MemberList || arr_MemberList.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arr_MemberList" :class="data.RS == 1? 'blacklist-row': data.RS == 3? 'freeze-row': ''">
                            <td v-for="header in reportHeaders" :key="header" :class="renderClassName(header, data)">
                                <template v-if="header == 'ACT' && (ML_E|| ML_D)">
                                    <span id="actionBtnCol" v-if="!isOUTMOB">
                                        <span>
                                            <div v-if="ML_E && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" class="member-list-same custom_tooltip mt-1">
                                                <i class="cil-color-border" @click='editMember(data)'></i> <!--here Edit -->
                                                <span class="tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                            </div>
                                            <div v-else-if="ML_E && isSENS == 1 && data.AGI != curAGI" class="member-list-same custom_tooltip mt-1">
                                                <i class="cil-color-border"></i> <!--here Edit -->
                                                <span class="tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                            </div>
                                            <div class="member-list-same custom_tooltip mt-1" v-if="checkModuleAccess3(constAccessType.edit) && data.RS == 1 &&  ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                                <i class="cil-action-undo" @click='unBlacklistMember(data)'></i> <!--here Remove -->
                                                <span class="tooltiptext">{{getLanguage["BTN"]["UDO"]}}</span>
                                            </div>
                                            <div class="member-list-same custom_tooltip mt-1" v-else-if="checkModuleAccess3(constAccessType.edit) && data.RS == 1 && isSENS == 1 && data.AGI != curAGI">
                                                <i class="cil-action-undo"></i> <!--here Remove -->
                                                <span class="tooltiptext">{{getLanguage["BTN"]["UDO"]}}</span>
                                            </div>
                                            <div v-if="checkModuleAccess3(constAccessType.add) && ML_D && data.RS != 1 &&  ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" class="member-list-same custom_tooltip mt-1">
                                                <i class="cil-ban" @click='blacklistMember(data)'></i> <!--here Remove -->
                                                <span class="tooltiptext">{{getLanguage["BTN"]["BLK"]}}</span>
                                            </div>
                                            <div v-else-if="checkModuleAccess3(constAccessType.add) && ML_D && data.RS != 1 && isSENS == 1 && data.AGI != curAGI" class="member-list-same custom_tooltip mt-1">
                                                <i class="cil-ban"></i> <!--here Remove -->
                                                <span class="tooltiptext">{{getLanguage["BTN"]["BLK"]}}</span>
                                            </div>
                                        </span>
                                        <span>
                                            <div v-if="ML_E && !isSubAgent &&  ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" class="member-list-same custom_tooltip mt-1">
                                                <i class="cil-settings" @click='editMemberGameSetting(data)'></i> <!--here Edit Member Game Setting -->
                                                <span class="tooltiptext">{{getLanguage["BTN"]["EDGS"]}}</span>
                                            </div>
                                            <div v-if="ML_E && isSubAgent && getUserInfo.IOL && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" class="member-list-same custom_tooltip mt-1">
                                                <i class="cil-settings" @click='editMemberGameSetting(data)'></i> <!--here Edit Member Game Setting for Outlet -->
                                                <span class="tooltiptext">{{getLanguage["BTN"]["EDGS"]}}</span>
                                            </div>
                                            <div v-else-if="ML_E && !isSubAgent && isSENS == 1 && data.AGI != curAGI" class="member-list-same custom_tooltip mt-1">
                                                <i class="cil-settings"></i> <!--here Edit Member Game Setting -->
                                                <span class="tooltiptext">{{getLanguage["BTN"]["EDGS"]}}</span>
                                            </div>
                                            <div class="member-list-same custom_tooltip mt-1" v-if="checkModuleAccess3(constAccessType.edit) && data.RS == 3 && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                                <i class="cil-action-undo" @click='unFreezeMember(data)'></i> <!--here Freeze -->
                                                <span class="tooltiptext">{{getLanguage["BTN"]["UFR"]}}</span>
                                            </div>
                                            <div class="member-list-same custom_tooltip mt-1" v-else-if="checkModuleAccess3(constAccessType.edit) && data.RS == 3 && isSENS == 1 && data.AGI != curAGI">
                                                <i class="cil-action-undo"></i> <!--here Freeze -->
                                                <span class="tooltiptext">{{getLanguage["BTN"]["UFR"]}}</span>
                                            </div>
                                            <div v-if="checkModuleAccess3(constAccessType.add) && ML_D && data.RS != 3 &&  ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" class="member-list-same custom_tooltip mt-1">
                                                <i class="cil-snowflake" @click='freezeMember(data)'></i> <!--here Freeze -->
                                                <span class="tooltiptext">{{getLanguage["BTN"]["FK"]}}</span>
                                            </div>
                                            <div v-else-if="checkModuleAccess3(constAccessType.add) && ML_D && data.RS != 3 && isSENS == 1 && data.AGI != curAGI" class="member-list-same custom_tooltip mt-1">
                                                <i class="cil-snowflake"></i> <!--here Freeze -->
                                                <span class="tooltiptext">{{getLanguage["BTN"]["FK"]}}</span>
                                            </div>
                                        </span>
                                    </span>
                                    <span id="actionBtnCol" v-if="isOUTMOB">
                                        <span>
                                            <CButton size="sm" type="button" class="btn-warning font-weight-bold text-white mr-2" @click="editMember(data)" v-if="ML_E && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                                {{getLanguage["BTN"]["ED"]}}
                                            </CButton>
                                            <CButton size="sm" type="submit" :class="data.HADLS ? 'btn-danger' : 'btn-success'" @click="manualTriggerDLS(data)" :disabled="data.HADLS" v-if="((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                                <span>
                                                    <span>{{getLanguage["DB"]["DLS"]}} {{ getLanguage["AFF"]["ACT"] }}<i class="fa fa-power-off m-0 ml-2" aria-hidden="true"></i></span>
                                                </span>
                                                <div class="spinner-border spinner-border-sm" v-if="data.bool_sendLoading"></div>
                                            </CButton>
                                        </span>
                                    </span>
                                </template>
                                <template v-else-if="header == 'NO'">
                                    {{CountItem(index+1)}}
                                </template>
                                <template v-else-if="header == 'AGT'">
                                    <span class="grid-line">{{ data.AGN }}</span>
                                    <span class="saggroupname">{{ data.SAGN }}</span>
                                    <span class="grid-line">{{ data.DMN }}</span>
                                    <span v-if=" ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" class="grid-line text-primary"><router-link :to="{ path:'/M/ML/CheckingMember', query:{ agi: data.AGI, i: data.RI}}">{{ data.RU }}</router-link></span>
                                    <span v-if=" (isSENS == 1 && data.AGI != curAGI)" class="grid-line text-primary">{{ data.RU }}</span>
                                </template>
                                <template v-else-if="header == 'ACC'">
                                    <span v-if=" ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" class="grid-line" @click="CheckingMember(data.AGI,data.I)">
                                        <div class="custom_tooltip">
                                            <span :style="getbgtooltip(data)" @click.stop>{{data.U}}</span>
                                            <span v-if="convertToBool(data.MT)" class="tooltiptext tooltip-right" :style="getbgtooltip(data)">{{data.MT}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="data.TW == 0">
                                            <img src="/src/assets/icons/nerverwithdraw.svg" class="nwithdraw-icon" />
                                            <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["MNM"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="data.HTWT">
                                            <img src="/src/assets/icons/newtransfer.svg" class="ntransfer-icon" />
                                            <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["PVP"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="data.RP">
                                            <img src="/src/assets/icons/referral.svg" class="referral-icon" />
                                            <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["RFB"]}}</span>
                                        </div>
                                        <div class="float-right pointer ml-1">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16">
                                                <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
                                            </svg>
                                        </div>
                                    </span>
                                    <span v-if="isSENS == 1 && data.AGI != curAGI" class="grid-line">
                                        <div class="custom_tooltip">
                                            <span :style="getbgtooltip(data)" @click.stop>{{data.U}}</span>
                                            <span v-if="convertToBool(data.MT)" class="tooltiptext tooltip-right" :style="getbgtooltip(data)">{{data.MT}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="data.TW == 0">
                                            <img src="/src/assets/icons/nerverwithdraw.svg" class="nwithdraw-icon" />
                                            <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["MNM"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="data.HTWT">
                                            <img src="/src/assets/icons/newtransfer.svg" class="ntransfer-icon" />
                                            <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["PVP"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="data.RP">
                                            <img src="/src/assets/icons/referral.svg" class="referral-icon" />
                                            <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["RFB"]}}</span>
                                        </div>
                                        <div class="float-right pointer ml-1">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16">
                                                <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
                                            </svg>
                                        </div>
                                    </span>
                                    <span class="grid-line mt-2 d-flex" v-if="!isOUTMOB">
                                        <div v-if="(isSENS == 1 && data.AGI == curAGI) || isSENS == 0" class="member-list-same custom_tooltip" @click="showAccessFailedMessage()">
                                            <router-link :to="MCMI_V ? { path:'/M/MCMI', query:{ agi: data.AGI, i: data.I, u: data.U, cf: 0}} : ''">
                                                <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" width="16" height="16" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                                                <g>
                                                <g>
                                                <circle cx="375.6" cy="350.5" r="15.1" />
                                                <circle cx="215.8" cy="350.5" r="15.1" />
                                                <circle cx="136.4" cy="350.5" r="15.1" />
                                                <circle cx="295.2" cy="350.5" r="15.1" />
                                                        </g>
                                                <path d="M101.6,512.1c-38-2-68.3-33.6-68.3-72.1V268.7c0-39.8,32.4-72.2,72.2-72.2H142v-85.2C142,49.9,193.1-0.1,256-0.1c62.8,0,113.9,50,113.9,111.3v85.1h36.6c39.8,0,72.2,32.4,72.2,72.2v77.3c0,5.2-4.2,9.4-9.4,9.4s-9.4-4.2-9.4-9.4v-77.3c0-29.4-23.9-53.3-53.3-53.3h-301c-29.4,0-53.3,23.9-53.3,53.3v171.4c0,29.4,23.9,53.3,53.3,53.3h301c29.4,0,53.3-23.9,53.3-53.3c0-5.2,4.2-9.4,9.4-9.4s9.4,4.2,9.4,9.4c0,39.8-32.4,72.2-72.2,72.2H101.6z M256,18.8c-52.4,0-95,41.4-95,92.4v85.2h190v-85.2C351,60.3,308.4,18.8,256,18.8z" />

                                                    </g>
                                                </svg>
                                            </router-link>
                                            <span v-if="data.TP > 0" class="custom-duplicated-count">{{ data.TP }}</span>
                                            <span class="tooltiptext">{{getLanguage["MEM"]["DUP0"]}}</span>
                                        </div>
                                        <div v-else-if="isSENS == 1 && data.AGI != curAGI" class="member-list-same custom_tooltip">
                                            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" width="16" height="16" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                                            <g>
                                            <g>
                                            <circle cx="375.6" cy="350.5" r="15.1" />
                                            <circle cx="215.8" cy="350.5" r="15.1" />
                                            <circle cx="136.4" cy="350.5" r="15.1" />
                                            <circle cx="295.2" cy="350.5" r="15.1" />
                                                        </g>
                                            <path d="M101.6,512.1c-38-2-68.3-33.6-68.3-72.1V268.7c0-39.8,32.4-72.2,72.2-72.2H142v-85.2C142,49.9,193.1-0.1,256-0.1c62.8,0,113.9,50,113.9,111.3v85.1h36.6c39.8,0,72.2,32.4,72.2,72.2v77.3c0,5.2-4.2,9.4-9.4,9.4s-9.4-4.2-9.4-9.4v-77.3c0-29.4-23.9-53.3-53.3-53.3h-301c-29.4,0-53.3,23.9-53.3,53.3v171.4c0,29.4,23.9,53.3,53.3,53.3h301c29.4,0,53.3-23.9,53.3-53.3c0-5.2,4.2-9.4,9.4-9.4s9.4,4.2,9.4,9.4c0,39.8-32.4,72.2-72.2,72.2H101.6z M256,18.8c-52.4,0-95,41.4-95,92.4v85.2h190v-85.2C351,60.3,308.4,18.8,256,18.8z" />

                                                    </g>
                                                </svg>
                                            <span v-if="data.TP > 0" class="custom-duplicated-count">{{ data.TP }}</span>
                                            <span class="tooltiptext">{{getLanguage["MEM"]["DUP0"]}}</span>
                                        </div>
                                        <div v-if="(isSENS == 1 && data.AGI == curAGI) || isSENS == 0" class="member-list-same custom_tooltip" @click="showAccessFailedMessage()">
                                            <router-link :to="MCMI_V ? { path:'/M/MCMI', query:{ agi: data.AGI, i: data.I, u: data.U, cf: 1}} : ''">
                                                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" width="16" height="16" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                                                <g>
                                                <g>
                                                <path d="M235.3,178.1c0,2.6-0.9,4.8-2.8,6.7c-1.9,1.8-4.1,2.8-6.8,2.8c-2.7,0-4.9-0.9-6.8-2.8s-2.8-4.1-2.8-6.8v-67.8c0-2.5,1-4.8,2.9-6.8c1.9-2,4.2-3,6.8-3s4.8,1,6.7,2.9c1.8,1.9,2.8,4.2,2.8,6.9V178.1z" />
                                                <path d="M270.1,157.8v19.3c0,2.6-0.9,4.8-2.8,6.7c-1.9,1.9-4.1,2.8-6.7,2.8s-4.8-0.9-6.7-2.8c-1.9-1.9-2.8-4.2-2.8-7v-66.4c0-2.8,1-5.2,2.9-7.1c1.9-1.9,4.3-2.9,7-2.9h22.4c8.9,0,16.1,2.7,21.7,8c5.6,5.4,8.4,12.3,8.4,20.9c0,8.5-2.6,15.4-7.9,20.6c-5.3,5.2-12.3,7.9-21,7.9H270.1z M270.1,117.6v23.5h12.2c3.1,0,5.7-1.1,8-3.4c2.3-2.3,3.4-5,3.4-8.2c0-3.3-1.1-6.1-3.2-8.4c-2.2-2.3-4.9-3.5-8.1-3.5H270.1z" />
                                                <path d="M451.3,359.1c-3.3-4.5-9.5-5.4-14-2.1c-4.5,3.3-5.4,9.5-2.1,14c14.5,19.7,25.4,41.4,32.7,64.2c-21.4-22-53.2-40.3-92.1-52.7c-1-3.2-2.1-6.4-3.2-9.6c-12.1-34.1-28.8-62.1-48.6-81.7c0.1-0.1,0.2-0.2,0.3-0.4c21.5,6.9,41.7,17.1,60.3,30.2c1.8,1.3,3.8,1.8,5.8,1.8c3.1,0,6.2-1.5,8.2-4.2c3.2-4.5,2.1-10.8-2.4-14c-18.2-12.9-37.8-23.2-58.7-30.6c32.9-42.9,60.3-89.5,60.3-132.4C397.8,63.6,334.2,0,256,0S114.2,63.6,114.2,141.8c0,30.5,13.9,65.7,42.6,107.7c5.7,8.3,11.7,16.5,17.9,24.6c-43.8,15.7-82.9,44.2-111.3,81.4C31,397.9,13.9,448.7,13.9,502.2c0,5.5,4.5,10,10,10h464.2c5.5,0,10-4.5,10-10C498.1,450.3,481.9,400.8,451.3,359.1z M352.2,375.9c-15.5-3.8-32-6.6-49.1-8.5c-1.9-12.2-8.6-23.2-18.4-30.6c8.5-9.6,17.4-19.7,26.3-30.1C327.7,323.6,341.7,347.5,352.2,375.9z M134.3,141.8c0-67.1,54.6-121.7,121.7-121.7s121.7,54.6,121.7,121.7c0,60.5-69.2,138.1-114.9,189.5c-2.3,2.6-4.6,5.2-6.8,7.7c-2.1-2.4-4.3-4.9-6.6-7.4C203.6,280,134.3,202.2,134.3,141.8z M227.3,336.8c-9.7,7.4-16.4,18.3-18.3,30.6c-17.2,1.9-33.6,4.8-49.2,8.5c10.5-28.4,24.5-52.3,41.2-69.3C210,317.2,218.9,327.3,227.3,336.8z M118.7,492.2H34.8c5.8-35,41.9-66.5,94.9-86.2C123.1,433.1,119.3,462.3,118.7,492.2z M44.5,434.8c21.6-67.1,74.4-121.8,143.4-144c0.1,0.1,0.2,0.2,0.3,0.3c-19.8,19.6-36.5,47.6-48.6,81.7c-1.1,3.2-2.2,6.4-3.2,9.6C97.6,394.8,65.9,413,44.5,434.8z M246,492.2H138.7c0.8-33.2,5.6-65.1,13.7-93.6c17.9-5.1,37.2-8.9,57.6-11.2c4.7,17.2,18.6,30.3,36,34L246,492.2L246,492.2z M258.8,402.3c-1.5,0.1-2.9,0.2-4.4,0.1c-14.5-0.8-26.1-12.9-26.1-27.6c0-9.3,4.7-17.9,12.3-23c2.7,3.1,5.3,6,7.9,8.9c1.9,2.2,4.6,3.4,7.5,3.4s5.6-1.2,7.5-3.4c2.5-2.9,5.1-5.8,7.9-8.9c7.5,5.1,12.3,13.7,12.3,23c0,3.7-0.8,7.4-2.2,10.8C277.6,394.6,269.1,401.2,258.8,402.3C258.9,402.3,258.8,402.3,258.8,402.3C258.4,402.3,258.8,402.3,258.8,402.3C257.4,402.4,258.8,402.3,258.8,402.3z M266,492.2v-70.8c16.9-3.6,30.4-16,35.5-32.4c0-0.1,0.1-0.3,0.1-0.4c0.1-0.4,0.3-0.8,0.4-1.2c20.4,2.3,39.7,6.1,57.6,11.2c8.1,28.6,12.9,60.5,13.7,93.6H266z M393.3,492.2c-0.7-29.9-4.4-59.1-11-86.2c53,19.7,89.1,51.2,94.9,86.2H393.3z" />
                                                <path d="M256,241.9c-54.3,0-98.5-44.2-98.5-98.5c0-54.3,44.2-98.5,98.5-98.5c54.3,0,98.5,44.2,98.5,98.5C354.5,197.8,310.3,241.9,256,241.9z M256,65c-43.2,0-78.4,35.2-78.4,78.5c0,43.2,35.2,78.4,78.4,78.4c43.3,0,78.5-35.2,78.5-78.4C334.5,100.2,299.3,65,256,65z" />
                                                <path d="M420.1,348.2c-2.9,0-5.8-1.3-7.8-3.8l-0.1-0.1c-3.5-4.3-2.8-10.6,1.6-14.1c4.3-3.5,10.6-2.8,14.1,1.6l0.1,0.1c3.5,4.3,2.8,10.6-1.6,14.1C424.5,347.4,422.3,348.2,420.1,348.2z" />
                                                        </g>
                                                    </g>
                                                </svg>
                                            </router-link>
                                            <span v-if="data.TRIP > 0" class="custom-duplicated-count">{{ data.TRIP }}</span>
                                            <span class="tooltiptext">{{getLanguage["MEM"]["DUP1"]}}</span>
                                        </div>
                                        <div v-else-if="isSENS == 1 && data.AGI != curAGI" class="member-list-same custom_tooltip">
                                            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" width="16" height="16" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                                            <g>
                                            <g>
                                            <path d="M235.3,178.1c0,2.6-0.9,4.8-2.8,6.7c-1.9,1.8-4.1,2.8-6.8,2.8c-2.7,0-4.9-0.9-6.8-2.8s-2.8-4.1-2.8-6.8v-67.8c0-2.5,1-4.8,2.9-6.8c1.9-2,4.2-3,6.8-3s4.8,1,6.7,2.9c1.8,1.9,2.8,4.2,2.8,6.9V178.1z" />
                                            <path d="M270.1,157.8v19.3c0,2.6-0.9,4.8-2.8,6.7c-1.9,1.9-4.1,2.8-6.7,2.8s-4.8-0.9-6.7-2.8c-1.9-1.9-2.8-4.2-2.8-7v-66.4c0-2.8,1-5.2,2.9-7.1c1.9-1.9,4.3-2.9,7-2.9h22.4c8.9,0,16.1,2.7,21.7,8c5.6,5.4,8.4,12.3,8.4,20.9c0,8.5-2.6,15.4-7.9,20.6c-5.3,5.2-12.3,7.9-21,7.9H270.1z M270.1,117.6v23.5h12.2c3.1,0,5.7-1.1,8-3.4c2.3-2.3,3.4-5,3.4-8.2c0-3.3-1.1-6.1-3.2-8.4c-2.2-2.3-4.9-3.5-8.1-3.5H270.1z" />
                                            <path d="M451.3,359.1c-3.3-4.5-9.5-5.4-14-2.1c-4.5,3.3-5.4,9.5-2.1,14c14.5,19.7,25.4,41.4,32.7,64.2c-21.4-22-53.2-40.3-92.1-52.7c-1-3.2-2.1-6.4-3.2-9.6c-12.1-34.1-28.8-62.1-48.6-81.7c0.1-0.1,0.2-0.2,0.3-0.4c21.5,6.9,41.7,17.1,60.3,30.2c1.8,1.3,3.8,1.8,5.8,1.8c3.1,0,6.2-1.5,8.2-4.2c3.2-4.5,2.1-10.8-2.4-14c-18.2-12.9-37.8-23.2-58.7-30.6c32.9-42.9,60.3-89.5,60.3-132.4C397.8,63.6,334.2,0,256,0S114.2,63.6,114.2,141.8c0,30.5,13.9,65.7,42.6,107.7c5.7,8.3,11.7,16.5,17.9,24.6c-43.8,15.7-82.9,44.2-111.3,81.4C31,397.9,13.9,448.7,13.9,502.2c0,5.5,4.5,10,10,10h464.2c5.5,0,10-4.5,10-10C498.1,450.3,481.9,400.8,451.3,359.1z M352.2,375.9c-15.5-3.8-32-6.6-49.1-8.5c-1.9-12.2-8.6-23.2-18.4-30.6c8.5-9.6,17.4-19.7,26.3-30.1C327.7,323.6,341.7,347.5,352.2,375.9z M134.3,141.8c0-67.1,54.6-121.7,121.7-121.7s121.7,54.6,121.7,121.7c0,60.5-69.2,138.1-114.9,189.5c-2.3,2.6-4.6,5.2-6.8,7.7c-2.1-2.4-4.3-4.9-6.6-7.4C203.6,280,134.3,202.2,134.3,141.8z M227.3,336.8c-9.7,7.4-16.4,18.3-18.3,30.6c-17.2,1.9-33.6,4.8-49.2,8.5c10.5-28.4,24.5-52.3,41.2-69.3C210,317.2,218.9,327.3,227.3,336.8z M118.7,492.2H34.8c5.8-35,41.9-66.5,94.9-86.2C123.1,433.1,119.3,462.3,118.7,492.2z M44.5,434.8c21.6-67.1,74.4-121.8,143.4-144c0.1,0.1,0.2,0.2,0.3,0.3c-19.8,19.6-36.5,47.6-48.6,81.7c-1.1,3.2-2.2,6.4-3.2,9.6C97.6,394.8,65.9,413,44.5,434.8z M246,492.2H138.7c0.8-33.2,5.6-65.1,13.7-93.6c17.9-5.1,37.2-8.9,57.6-11.2c4.7,17.2,18.6,30.3,36,34L246,492.2L246,492.2z M258.8,402.3c-1.5,0.1-2.9,0.2-4.4,0.1c-14.5-0.8-26.1-12.9-26.1-27.6c0-9.3,4.7-17.9,12.3-23c2.7,3.1,5.3,6,7.9,8.9c1.9,2.2,4.6,3.4,7.5,3.4s5.6-1.2,7.5-3.4c2.5-2.9,5.1-5.8,7.9-8.9c7.5,5.1,12.3,13.7,12.3,23c0,3.7-0.8,7.4-2.2,10.8C277.6,394.6,269.1,401.2,258.8,402.3C258.9,402.3,258.8,402.3,258.8,402.3C258.4,402.3,258.8,402.3,258.8,402.3C257.4,402.4,258.8,402.3,258.8,402.3z M266,492.2v-70.8c16.9-3.6,30.4-16,35.5-32.4c0-0.1,0.1-0.3,0.1-0.4c0.1-0.4,0.3-0.8,0.4-1.2c20.4,2.3,39.7,6.1,57.6,11.2c8.1,28.6,12.9,60.5,13.7,93.6H266z M393.3,492.2c-0.7-29.9-4.4-59.1-11-86.2c53,19.7,89.1,51.2,94.9,86.2H393.3z" />
                                            <path d="M256,241.9c-54.3,0-98.5-44.2-98.5-98.5c0-54.3,44.2-98.5,98.5-98.5c54.3,0,98.5,44.2,98.5,98.5C354.5,197.8,310.3,241.9,256,241.9z M256,65c-43.2,0-78.4,35.2-78.4,78.5c0,43.2,35.2,78.4,78.4,78.4c43.3,0,78.5-35.2,78.5-78.4C334.5,100.2,299.3,65,256,65z" />
                                            <path d="M420.1,348.2c-2.9,0-5.8-1.3-7.8-3.8l-0.1-0.1c-3.5-4.3-2.8-10.6,1.6-14.1c4.3-3.5,10.6-2.8,14.1,1.6l0.1,0.1c3.5,4.3,2.8,10.6-1.6,14.1C424.5,347.4,422.3,348.2,420.1,348.2z" />
                                                        </g>
                                                    </g>
                                                </svg>
                                            <span v-if="data.TRIP > 0" class="custom-duplicated-count">{{ data.TRIP }}</span>
                                            <span class="tooltiptext">{{getLanguage["MEM"]["DUP1"]}}</span>
                                        </div>
                                        <div v-if="(isSENS == 1 && data.AGI == curAGI) || isSENS == 0" class="member-list-same custom_tooltip" @click="showAccessFailedMessage()">
                                            <router-link :to="MCMI_V ? { path:'/M/MCMI', query:{ agi: data.AGI, i: data.I, u: data.U, cf: 2}} : ''">
                                                <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" width="16" height="16" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                                                <path d="M9.6,512c-5.3,0-9.5-4.3-9.5-9.5V439c0-5.3,4.3-9.5,9.5-9.5h11.9v-51.8c0-5.3,4.3-9.5,9.5-9.5H42V182.7H9.6c-5.3,0-9.5-4.3-9.5-9.5v-61.3c0-3.8,2.3-7.4,5.8-8.9L252.3,0.7c1.1-0.5,2.4-0.7,3.7-0.7c1.3,0,2.5,0.2,3.7,0.7L506,103c3.6,1.5,5.9,4.9,5.9,8.9v61.3c0,5.3-4.3,9.5-9.5,9.5H470v185.4h10.9c5.3,0,9.5,4.3,9.5,9.5v51.8h11.9c5.3,0,9.5,4.3,9.5,9.5v63.4c0,5.3-4.3,9.5-9.5,9.5H9.6z M19.1,492.9h473.7v-44.3H19.1V492.9z M388.2,429.5h83.2v-42.3h-83.2V429.5z M122.4,368.1h10.9c5.3,0,9.5,4.3,9.5,9.5v51.8h226.3v-51.8c0-5.3,4.3-9.5,9.5-9.5h10.9V182.7H122.4V368.1z M40.6,429.5h83.2v-42.3H40.6V429.5zM408.7,368.1H451V182.7h-42.3V368.1z M61,368.1h42.3V182.7H61V368.1z M19.1,118.2v45.5h473.7v-45.5L256,19.9L19.1,118.2z" />
                                                <path d="M164,121.4c-5.3,0-9.5-4.3-9.5-9.5c0-5.3,4.3-9.5,9.5-9.5h184c5.3,0,9.5,4.3,9.5,9.5c0,5.3-4.3,9.5-9.5,9.5H164z" />
                                                <path d="M256,397.4c-5.3,0-9.5-4.3-9.5-9.5V376l-3.9-1.4c-16-5.7-26.8-20.9-26.8-37.9c0-5.3,4.3-9.5,9.5-9.5c5.3,0,9.5,4.3,9.5,9.5c0,11.7,9.5,21.1,21.1,21.1c11.7,0,21.1-9.5,21.1-21.1s-9.5-21.1-21.1-21.1c-22.2,0-40.2-18-40.2-40.2c0-17,10.8-32.2,26.8-37.9l3.9-1.4v-11.9c0-5.3,4.3-9.5,9.5-9.5c5.3,0,9.5,4.3,9.5,9.5v11.9l3.9,1.4c16,5.7,26.8,20.9,26.8,37.9c0,5.3-4.3,9.5-9.5,9.5s-9.5-4.3-9.5-9.5c0-11.7-9.5-21.1-21.1-21.1c-11.7,0-21.1,9.5-21.1,21.1s9.5,21.1,21.1,21.1c22.2,0,40.2,18,40.2,40.2c0,17-10.8,32.2-26.8,37.9l-3.9,1.4v11.9C265.5,393.2,261.3,397.4,256,397.4z" />
                                                </svg>
                                            </router-link>
                                            <span v-if="data.TBA > 0" class="custom-duplicated-count">{{ data.TBA }}</span>
                                            <span class="tooltiptext">{{getLanguage["MEM"]["DUP2"]}}</span>
                                        </div>
                                        <div v-else-if="isSENS == 1 && data.AGI != curAGI" class="member-list-same custom_tooltip">
                                            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" width="16" height="16" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                                            <path d="M9.6,512c-5.3,0-9.5-4.3-9.5-9.5V439c0-5.3,4.3-9.5,9.5-9.5h11.9v-51.8c0-5.3,4.3-9.5,9.5-9.5H42V182.7H9.6c-5.3,0-9.5-4.3-9.5-9.5v-61.3c0-3.8,2.3-7.4,5.8-8.9L252.3,0.7c1.1-0.5,2.4-0.7,3.7-0.7c1.3,0,2.5,0.2,3.7,0.7L506,103c3.6,1.5,5.9,4.9,5.9,8.9v61.3c0,5.3-4.3,9.5-9.5,9.5H470v185.4h10.9c5.3,0,9.5,4.3,9.5,9.5v51.8h11.9c5.3,0,9.5,4.3,9.5,9.5v63.4c0,5.3-4.3,9.5-9.5,9.5H9.6z M19.1,492.9h473.7v-44.3H19.1V492.9z M388.2,429.5h83.2v-42.3h-83.2V429.5z M122.4,368.1h10.9c5.3,0,9.5,4.3,9.5,9.5v51.8h226.3v-51.8c0-5.3,4.3-9.5,9.5-9.5h10.9V182.7H122.4V368.1z M40.6,429.5h83.2v-42.3H40.6V429.5zM408.7,368.1H451V182.7h-42.3V368.1z M61,368.1h42.3V182.7H61V368.1z M19.1,118.2v45.5h473.7v-45.5L256,19.9L19.1,118.2z" />
                                            <path d="M164,121.4c-5.3,0-9.5-4.3-9.5-9.5c0-5.3,4.3-9.5,9.5-9.5h184c5.3,0,9.5,4.3,9.5,9.5c0,5.3-4.3,9.5-9.5,9.5H164z" />
                                            <path d="M256,397.4c-5.3,0-9.5-4.3-9.5-9.5V376l-3.9-1.4c-16-5.7-26.8-20.9-26.8-37.9c0-5.3,4.3-9.5,9.5-9.5c5.3,0,9.5,4.3,9.5,9.5c0,11.7,9.5,21.1,21.1,21.1c11.7,0,21.1-9.5,21.1-21.1s-9.5-21.1-21.1-21.1c-22.2,0-40.2-18-40.2-40.2c0-17,10.8-32.2,26.8-37.9l3.9-1.4v-11.9c0-5.3,4.3-9.5,9.5-9.5c5.3,0,9.5,4.3,9.5,9.5v11.9l3.9,1.4c16,5.7,26.8,20.9,26.8,37.9c0,5.3-4.3,9.5-9.5,9.5s-9.5-4.3-9.5-9.5c0-11.7-9.5-21.1-21.1-21.1c-11.7,0-21.1,9.5-21.1,21.1s9.5,21.1,21.1,21.1c22.2,0,40.2,18,40.2,40.2c0,17-10.8,32.2-26.8,37.9l-3.9,1.4v11.9C265.5,393.2,261.3,397.4,256,397.4z" />
                                                </svg>
                                            <span v-if="data.TBA > 0" class="custom-duplicated-count">{{ data.TBA }}</span>
                                            <span class="tooltiptext">{{getLanguage["MEM"]["DUP2"]}}</span>
                                        </div>
                                        <div v-if="(isSENS == 1 && data.AGI == curAGI) || isSENS == 0" class="member-list-same custom_tooltip" @click="showAccessFailedMessage()">
                                            <router-link :to="MCMI_V ? { path:'/M/MCMI', query:{ agi: data.AGI, i: data.I, u: data.U, cf: 3}} : ''">
                                                <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" width="16" height="16" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                                                <path d="M32,479.3v-0.1h-5.8C11.8,479.2,0,467.4,0,453V157.4c0-14.5,11.8-26.2,26.2-26.2h180.6c5.4,0,9.7,4.4,9.7,9.7c0,5.4-4.4,9.7-9.7,9.7H19.5v79h187.2c5.4,0,9.7,4.4,9.7,9.7s-4.4,9.7-9.7,9.7H19.5v210.4h473V338.1c0-5.4,4.4-9.7,9.7-9.7c5.4,0,9.7,4.4,9.7,9.7v114.9c0,14.5-11.8,26.2-26.2,26.2H32z" />
                                                <path d="M75.4,347.9c-5.4,0-9.7-4.4-9.7-9.7c0-5.4,4.4-9.7,9.7-9.7h65.7c5.4,0,9.7,4.4,9.7,9.7c0,5.4-4.4,9.7-9.7,9.7H75.4z" />
                                                <path d="M387.3,347.9c-1.7,0-3.4-0.4-4.9-1.3c-44.9-25.9-74.4-51.5-92.9-80.7c-18.4-29-26.9-63.5-26.9-108.4V91.9c0-3.9,2.3-7.5,5.9-9l114.9-49.3c1.2-0.5,2.5-0.8,3.9-0.8c1.4,0,2.7,0.3,3.9,0.8l114.9,49.3c3.6,1.5,5.9,5.1,5.9,9v65.7c0,45-8.5,79.4-26.9,108.4c-18.4,29.2-48,54.8-92.9,80.6C390.7,347.4,389,347.9,387.3,347.9z M387.3,327.4l3.6-2.7c74.9-45,101.4-88.7,101.4-167.1V98.3L387.2,53.1l-105,45.1v59.2c0,78.3,26.6,122,101.4,167.1L387.3,327.4z" />
                                                <path d="M370.4,232.9c-3.1-0.2-5.8-1.7-7.6-4.3L330,179.3c-1.4-2.2-1.9-4.7-1.4-7.3c0.5-2.6,2-4.7,4.2-6.3c1.5-1,3.3-1.6,5.3-1.6c3.3,0,6.4,1.6,8.1,4.3l25.5,38.1l57.3-71.6c1.9-2.3,4.6-3.7,7.6-3.7c2.3,0,4.4,0.7,6.1,2.1c4.2,3.4,4.9,9.6,1.6,13.8l-65.6,82.1c-1.9,2.3-4.6,3.7-7.6,3.7H370.4z" />
                                                </svg>
                                            </router-link>
                                            <span v-if="data.TBN > 0" class="custom-duplicated-count">{{ data.TBN }}</span>
                                            <span class="tooltiptext">{{getLanguage["MEM"]["DUP3"]}}</span>
                                        </div>
                                        <div v-else-if="isSENS == 1 && data.AGI != curAGI" class="member-list-same custom_tooltip">
                                            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" width="16" height="16" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                                            <path d="M32,479.3v-0.1h-5.8C11.8,479.2,0,467.4,0,453V157.4c0-14.5,11.8-26.2,26.2-26.2h180.6c5.4,0,9.7,4.4,9.7,9.7c0,5.4-4.4,9.7-9.7,9.7H19.5v79h187.2c5.4,0,9.7,4.4,9.7,9.7s-4.4,9.7-9.7,9.7H19.5v210.4h473V338.1c0-5.4,4.4-9.7,9.7-9.7c5.4,0,9.7,4.4,9.7,9.7v114.9c0,14.5-11.8,26.2-26.2,26.2H32z" />
                                            <path d="M75.4,347.9c-5.4,0-9.7-4.4-9.7-9.7c0-5.4,4.4-9.7,9.7-9.7h65.7c5.4,0,9.7,4.4,9.7,9.7c0,5.4-4.4,9.7-9.7,9.7H75.4z" />
                                            <path d="M387.3,347.9c-1.7,0-3.4-0.4-4.9-1.3c-44.9-25.9-74.4-51.5-92.9-80.7c-18.4-29-26.9-63.5-26.9-108.4V91.9c0-3.9,2.3-7.5,5.9-9l114.9-49.3c1.2-0.5,2.5-0.8,3.9-0.8c1.4,0,2.7,0.3,3.9,0.8l114.9,49.3c3.6,1.5,5.9,5.1,5.9,9v65.7c0,45-8.5,79.4-26.9,108.4c-18.4,29.2-48,54.8-92.9,80.6C390.7,347.4,389,347.9,387.3,347.9z M387.3,327.4l3.6-2.7c74.9-45,101.4-88.7,101.4-167.1V98.3L387.2,53.1l-105,45.1v59.2c0,78.3,26.6,122,101.4,167.1L387.3,327.4z" />
                                            <path d="M370.4,232.9c-3.1-0.2-5.8-1.7-7.6-4.3L330,179.3c-1.4-2.2-1.9-4.7-1.4-7.3c0.5-2.6,2-4.7,4.2-6.3c1.5-1,3.3-1.6,5.3-1.6c3.3,0,6.4,1.6,8.1,4.3l25.5,38.1l57.3-71.6c1.9-2.3,4.6-3.7,7.6-3.7c2.3,0,4.4,0.7,6.1,2.1c4.2,3.4,4.9,9.6,1.6,13.8l-65.6,82.1c-1.9,2.3-4.6,3.7-7.6,3.7H370.4z" />
                                                </svg>
                                            <span v-if="data.TBN > 0" class="custom-duplicated-count">{{ data.TBN }}</span>
                                            <span class="tooltiptext">{{getLanguage["MEM"]["DUP3"]}}</span>
                                        </div>
                                    </span>
                                    <span class="grid-line d-flex" v-if="!isOUTMOB">
                                        <div v-if="(isSENS == 1 && data.AGI == curAGI) || isSENS == 0" class="member-list-same custom_tooltip" @click="showAccessFailedMessage()">
                                            <router-link :to="MCMI_V ? { path:'/M/MCMI', query:{ agi: data.AGI, i: data.I, u: data.U, cf: 4}} : ''">
                                                <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 511.9 511.9" width="16" height="16" style="enable-background:new 0 0 511.9 511.9;" xml:space="preserve">
                                                <g>
                                                <path d="M152.4,511.8c-25.6,0-46.4-20.8-46.4-46.4V46.5c0-25.6,20.8-46.4,46.4-46.4h207.1c25.6,0,46.4,20.8,46.4,46.4v418.9c0,25.6-20.8,46.4-46.4,46.4H152.4z M124.8,465.4c0,15.1,12.3,27.5,27.5,27.5h207.1c15.1,0,27.5-12.3,27.5-27.5v-46.5H124.8V465.4zM124.8,400H387V90.6H124.8V400z M152.4,19c-15.1,0-27.5,12.3-27.5,27.5v25.1h262.2V46.5c0-15.1-12.3-27.5-27.5-27.5H152.4z" />
                                                <path d="M255.9,474.9c-11.1,0-20.1-9-20.1-20.1s9-20.1,20.1-20.1c11.1,0,20.1,9,20.1,20.1S267,474.9,255.9,474.9z" />
                                                        </g>
                                                    </svg>
                                            </router-link>
                                            <span v-if="data.TPN > 0" class="custom-duplicated-count">{{ data.TPN }}</span>
                                            <span class="tooltiptext">{{getLanguage["MEM"]["DUP4"]}}</span>
                                        </div>
                                        <div v-else-if="isSENS == 1 && data.AGI != curAGI" class="member-list-same custom_tooltip">
                                            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 511.9 511.9" width="16" height="16" style="enable-background:new 0 0 511.9 511.9;" xml:space="preserve">
                                            <g>
                                            <path d="M152.4,511.8c-25.6,0-46.4-20.8-46.4-46.4V46.5c0-25.6,20.8-46.4,46.4-46.4h207.1c25.6,0,46.4,20.8,46.4,46.4v418.9c0,25.6-20.8,46.4-46.4,46.4H152.4z M124.8,465.4c0,15.1,12.3,27.5,27.5,27.5h207.1c15.1,0,27.5-12.3,27.5-27.5v-46.5H124.8V465.4zM124.8,400H387V90.6H124.8V400z M152.4,19c-15.1,0-27.5,12.3-27.5,27.5v25.1h262.2V46.5c0-15.1-12.3-27.5-27.5-27.5H152.4z" />
                                            <path d="M255.9,474.9c-11.1,0-20.1-9-20.1-20.1s9-20.1,20.1-20.1c11.1,0,20.1,9,20.1,20.1S267,474.9,255.9,474.9z" />
                                                        </g>
                                                    </svg>
                                            <span v-if="data.TPN > 0" class="custom-duplicated-count">{{ data.TPN }}</span>
                                            <span class="tooltiptext">{{getLanguage["MEM"]["DUP4"]}}</span>
                                        </div>
                                        <div v-if="(isSENS == 1 && data.AGI == curAGI) || isSENS == 0" class="member-list-same custom_tooltip" @click="showAccessFailedMessage()">
                                            <router-link :to="MCMI_V ? { path:'/M/MCMI', query:{ agi: data.AGI, i: data.I, u: data.U, cf: 5}} : ''">
                                                <img src="../../../assets/icons/last-best-ip.svg" width="16" />
                                            </router-link>
                                            <span v-if="data.TGBIP > 0" class="custom-duplicated-count">{{ data.TGBIP }}</span>
                                            <span class="tooltiptext">{{getLanguage["MEM"]["DUP5"]}}</span>
                                        </div>
                                        <div v-else-if="isSENS == 1 && data.AGI != curAGI" class="member-list-same custom_tooltip">
                                            <img src="../../../assets/icons/last-best-ip.svg" width="16" />
                                            <span v-if="data.TGBIP > 0" class="custom-duplicated-count">{{ data.TGBIP }}</span>
                                            <span class="tooltiptext">{{getLanguage["MEM"]["DUP5"]}}</span>
                                        </div>
                                        <div v-if="(isSENS == 1 && data.AGI == curAGI) || isSENS == 0" class="member-list-same custom_tooltip" @click="showAccessFailedMessage()">
                                            <router-link :to="MCMI_V ? { path:'/M/MCMI', query:{ agi: data.AGI, i: data.I, u: data.U, cf: 6}} : ''">
                                                <img src="../../../assets/icons/last-login-ip.svg" width="16" />
                                            </router-link>
                                            <span v-if="data.TLIP > 0" class="custom-duplicated-count">{{ data.TLIP }}</span>
                                            <span class="tooltiptext">{{getLanguage["MEM"]["DUP6"]}}</span>
                                        </div>
                                        <div v-else-if="isSENS == 1 && data.AGI != curAGI" class="member-list-same custom_tooltip">
                                            <img src="../../../assets/icons/last-login-ip.svg" width="16" />
                                            <span v-if="data.TLIP > 0" class="custom-duplicated-count">{{ data.TLIP }}</span>
                                            <span class="tooltiptext">{{getLanguage["MEM"]["DUP6"]}}</span>
                                        </div>
                                        <div v-if="(isSENS == 1 && data.AGI == curAGI) || isSENS == 0" class="member-list-same custom_tooltip" @click="showAccessFailedMessage()">
                                            <router-link :to="MCMI_V ? { path:'/M/MCMI', query:{ agi: data.AGI, i: data.I, u: data.U, cf: 7}} : ''">
                                                <img src="../../../assets/icons/last-system-ip.svg" width="16" />
                                            </router-link>
                                            <span v-if="data.TSI > 0" class="custom-duplicated-count">{{ data.TSI }}</span>
                                            <span class="tooltiptext">{{getLanguage["MEM"]["DUP7"]}}</span>
                                        </div>
                                        <div v-else-if="isSENS == 1 && data.AGI != curAGI" class="member-list-same custom_tooltip">
                                            <img src="../../../assets/icons/last-system-ip.svg" width="16" />
                                            <span v-if="data.TSI > 0" class="custom-duplicated-count">{{ data.TSI }}</span>
                                            <span class="tooltiptext">{{getLanguage["MEM"]["DUP7"]}}</span>
                                        </div>
                                    </span>
                                </template>
                                <template v-else-if="header == 'CIP'">
                                    <span class="grid-line"><!--<router-link :to="{ path:'/M/MCMI', query:{ agi: data.AGI, i: data.I, u: data.U, cf: 1}}">{{ data.CIP }}</router-link>--></span>
                                    <span class="grid-line">
                                        <a target="_blank" :href="checkIpAddress(data.CIP)">
                                            {{ data.CIP }}
                                            <div class="custom_tooltip" v-if="data.TBBCIP>0">
                                                ({{data.TBBCIP}})
                                                <span class="tooltiptext2">{{getLanguage["HELP"]["TBBIP"]}}</span>
                                            </div>
                                        </a>
                                    </span>
                                    <span class="grid-line">{{ data.DMN }}</span>
                                    <span class="grid-line">{{ formatDateTime(data.CTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</span>
                                </template>

                                <template v-else-if="header == 'LFPI'">
                                    <div style="text-align:center;display:block">
                                        <span v-if="data.TSI > 0 && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" @click="getSystemId(data)" :class="{opened: opened.includes(data.I)}" class="pointer">
                                            <span style="color:darkorange">({{ data.TSI }})</span> / <span style="color:red">({{ data.TM }})</span>
                                        </span>
                                        <span v-if="data.TSI > 0 && isSENS == 1 && data.AGI != curAGI" :class="{opened: opened.includes(data.I)}" class="pointer">
                                            <span style="color:darkorange">({{ data.TSI }})</span> / <span style="color:red">({{ data.TM }})</span>
                                        </span>
                                        <span class="grid-line" v-else>-</span>
                                        <table class='p-4 mt-2' v-if="opened.includes(data.I)" style="width: 100%; background: #ebedef">
                                            <thead>
                                                <tr>
                                                    <th>{{ getLanguage['LOGRPT']['SI'] }}</th>
                                                    <th>{{ getLanguage['LOGRPT']['DT'] }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <template v-for="(row,index) in arry_systemId[data.I]">
                                                    <tr style="text-align: left">
                                                        <td v-if="((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" @click="row.MI>0?toggleFingPrintId(row,data.I):{}" :class="{opened: opened.includes(row.UBI+'_'+row.SI)}" :style="[row.MI>0?{'cursor':'pointer'}:{}]">{{ row.SI }} <span style="color:red">({{row.MI}})</span></td>
                                                        <td v-else-if="(isSENS == 1 && data.AGI != curAGI)" :class="{opened: opened.includes(row.UBI+'_'+row.SI)}" :style="[row.MI>0?{'cursor':'pointer'}:{}]">{{ row.SI }} <span style="color:red">({{row.MI}})</span></td>
                                                        <td v-else></td>
                                                        <td>{{ formatDateTime(row.UTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                                                    </tr>
                                                    <tr v-if="opened.includes(row.UBI+'_'+row.SI) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" style="background: darkred">
                                                        <td colspan="2" style="padding:2px">
                                                            <table class='p-4' style="width: 100%; background: #ebedef;margin-top:1px">
                                                                <thead>
                                                                    <tr>
                                                                        <th style="background: darkgoldenrod;padding:0.25rem">{{getLanguage['GL']['NO']}}</th>
                                                                        <th style="background: darkgoldenrod; padding: 0.25rem">{{ getLanguage['LOGRPT']['ACC'] }}</th>
                                                                        <th style="background: darkgoldenrod; padding: 0.25rem">{{ getLanguage['LOGRPT']['DT'] }}</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr v-for="(item,index) in arry_visitorMembers[row.UBI+'_'+row.SI]" style="text-align:left">
                                                                        <td style="text-align:center">{{ CountItem(index+1) }}</td>
                                                                        <td  @click="showAccessFailedMessage()">
                                                                            <router-link :to="MCMI_V ? { path:'/M/MCMI', query:{ agi: item.AGI, i: item.MI, u: item.UB, cf: 7}} : ''" :target="MCMI_V ? '_blank' : null">{{ item.UB }}</router-link>
                                                                        </td>
                                                                        <td style="text-align: right;">{{ formatDateTime(item.UTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                    <tr v-else-if="opened.includes(row.UBI+'_'+row.SI) && (isSENS == 1 && data.AGI != curAGI)" style="background: darkred">
                                                        <td colspan="2" style="padding:2px">
                                                            <table class='p-4' style="width: 100%; background: #ebedef;margin-top:1px">
                                                                <thead>
                                                                    <tr>
                                                                        <th style="background: darkgoldenrod;padding:0.25rem">{{getLanguage['GL']['NO']}}</th>
                                                                        <th style="background: darkgoldenrod; padding: 0.25rem">{{ getLanguage['LOGRPT']['ACC'] }}</th>
                                                                        <th style="background: darkgoldenrod; padding: 0.25rem">{{ getLanguage['LOGRPT']['DT'] }}</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr v-for="(item,index) in arry_visitorMembers[row.UBI+'_'+row.SI]" style="text-align:left">
                                                                        <td style="text-align:center">{{ CountItem(index+1) }}</td>
                                                                        <td>
                                                                            {{ item.UB }}
                                                                        </td>
                                                                        <td style="text-align: right;">{{ formatDateTime(item.UTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                </template>
                                            </tbody>
                                        </table>
                                    </div>
                                </template>

                                <template v-else-if="header == 'LDTS'">
                                    <span class="grid-line" v-if="data.LDA != null && data.LDA != 0">{{ formatNumber(data.LDA, 2, data.CS) }}</span>
                                    <span class="grid-line" v-else>-</span>
                                    <span class="grid-line" v-if="data.LDA != null && data.LDA != 0">{{ formatDateTime(data.LDTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</span>
                                </template>
                                <template v-else-if="header == 'PTTS'">
                                    <span class="grid-line" v-if="data.PI != null && data.PI != 0">{{ formatDateTime(data.PTTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</span>
                                    <span class="grid-line" v-else>-</span>
                                </template>
                                <template v-else-if="header == 'LLTS_LLIP'">
                                    <span class="grid-line">{{ formatDateTime(data.LLTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</span>
                                    <span class="grid-line"><a target="_blank" :href="checkIpAddress(data.LLIP)">{{data.LLIP}}</a></span>
                                </template>

                                <template v-else-if="header == 'MEMMW'">
                                    <span class="grid-line" v-if="MBA_A && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" style="color:blue;cursor:pointer;" @click="newRequest(data)">
                                        {{ formatNumber(data.MEMMW, 2, data.CS) }}
                                    </span>
                                    <span class="grid-line" v-else-if="MBA_A && (isSENS == 1 && data.AGI != curAGI)">
                                        {{ formatNumber(data.MEMMW, 2, data.CS) }}
                                    </span>
                                    <span class="grid-line" v-else>
                                        {{ formatNumber(data.MEMMW, 2, data.CS) }}
                                    </span>
                                </template>
                                <template v-else-if="header == 'MEMPW'">
                                    <span class="grid-line">
                                        {{ formatNumber(data.MEMPW, 2, data.CS) }}
                                    </span>
                                </template>
                                <template v-else-if="header == 'CBL'">
                                    <span class="grid-line">
                                        {{ formatNumber(data.CBL, 2, data.CS) }}
                                    </span>
                                </template>
                                <template v-else-if="header == 'D'">
                                    <span class="grid-line">
                                        {{ formatNumber(data.TD, 2, data.CS) }}
                                    </span>
                                </template>
                                <template v-else-if="header == 'TW'">
                                    <span class="grid-line">
                                        {{ formatNumber(data.TW, 2, data.CS) }}
                                    </span>
                                </template>
                                <template v-else-if="header == 'BA'">
                                    <span v-if="data.BankList.length != 0">
                                        <div v-for="(ydata,yindex) in data.BankList">
                                            <div class="custom_tooltip">
                                                <span :class="ydata.RS == 1? 'blacklist-row': ydata.RS == 3? 'freeze-row' : ydata.RS == 4? 'warninglist-row' : ydata.IB? 'highrisk-row':''">{{ HideInfo(HideBankInfo, ydata.BA, 4) }} ({{ ydata.BNM }}) - {{ HideInfo(HideBankInfo, ydata.BAN, 4) }}</span>
                                                <span v-if="getUserInfo.AT == 0 && ydata.DBAC > 1">({{ ydata.DBAC }})</span>
                                                <span v-if="ydata.IB && ydata.RS==2" class="tooltiptext" style="background:red">{{getLanguage['BANK']['SBA']}}</span>
                                            </div>
                                            <div class="float-left mr-1 custom_tooltip pointer" v-if="ydata.RS == 1 && getUserInfo.AT == 0" @click='unBlockMemberBank(ydata, data.AGI, data.I)'>
                                                <i class="fa-solid fa-lock-open" style="color: rgb(201, 84, 90)"></i>
                                                <span class="tooltiptext" style="background:red">{{getLanguage['BTN']['UDO']}}</span>
                                            </div>
                                        </div>
                                    </span>
                                    <span v-else>-</span>
                                </template>
                                <template v-else-if="header == 'RSN'">
                                    <span v-if="data.RSN != ''">{{data.RSN}}</span>
                                    <span v-else>{{getLanguage["MEM"]["DIR"]}}</span>
                                </template>
                                <template v-else-if="header == 'BR'">
                                    <span v-if="data.BR != null && data.BR != '' && (data.RS == 1 || data.RS == 3) ">{{ renderBlackListReason(data.BR) }}</span>
                                    <span v-else-if="data.RS == 2 && data.R != null && data.R != ''">{{ data.R }}</span>
                                    <span v-else>-</span>
                                </template>
                                <template v-else-if="header == 'MRI'">
                                    <span v-if="data.RN != null && data.RN != ''">{{ReturnMemberRank(data.RN,data.CNN, data.KHN, data.IDN, data.KRN,data.MYN,data.THN,data.VNN,data.ION)}}</span>
                                    <span v-else>-</span>
                                </template>
                                <template v-else-if="header == 'LLD'">
                                    <div class="grid-line position-absolute custom_tooltip">
                                        <span type="button" data-toggle="tooltip" data-placement="left" :title="renderLoginDetails(data, 1)">
                                            <span>{{ renderLoginDetails(data, 0) }}</span>
                                        </span>
                                    </div>
                                </template>
                                <template v-else-if="header == 'MKT'">
                                    {{ data.AN }}
                                </template>
                                <template v-else-if="header == 'DEV'">
                                    {{ getDevice(data.IM) }}
                                </template>
                                <template v-if="header == 'DA' && ML_E">
                                    <div class="d-flex justify-content-center" v-if="((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                        <CInput type="number" placeholder="0" size="sm" :value="data.depositAmt" @change="v => data.depositAmt = v" class="mwidth150" :prepend="data.CS">
                                            <template #append>
                                                <CButton size="sm" type="submit" color="primary" style="min-width: auto; z-index: 0; " @click="transactionShortcut(data, 1)">
                                                    <span><i class="fa fa-paper-plane m-0"></i></span>
                                                </CButton>
                                            </template>
                                        </CInput>
                                    </div>
                                    <div class="d-flex justify-content-center" v-else-if="(isSENS == 1 && data.AGI != curAGI)">
                                        <CInput type="number" placeholder="0" size="sm" :value="data.depositAmt" @change="v => data.depositAmt = v" class="mwidth150" :prepend="data.CS">
                                            <template #append>
                                                <CButton size="sm" type="submit" color="primary" style="min-width: auto; z-index: 0; ">
                                                    <span><i class="fa fa-paper-plane m-0"></i></span>
                                                </CButton>
                                            </template>
                                        </CInput>
                                    </div>
                                </template>
                                <template v-if="header == 'WA' && ML_E">
                                    <div class="d-flex justify-content-center" v-if="((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                        <CInput type="number" placeholder="0" size="sm" :value="data.withdrawAmt" @change="v => data.withdrawAmt = v" class="mwidth150" :prepend="data.CS">
                                            <template #append>
                                                <CButton size="sm" type="submit" color="primary" style="min-width: auto; z-index: 0; " @click="transactionShortcut(data, 2)">
                                                    <span><i class="fa fa-paper-plane m-0"></i></span>
                                                </CButton>
                                            </template>
                                        </CInput>
                                    </div>
                                    <div class="d-flex justify-content-center" v-else-if="(isSENS == 1 && data.AGI != curAGI)">
                                        <CInput type="number" placeholder="0" size="sm" :value="data.withdrawAmt" @change="v => data.withdrawAmt = v" class="mwidth150" :prepend="data.CS">
                                            <template #append>
                                                <CButton size="sm" type="submit" color="primary" style="min-width: auto; z-index: 0; ">
                                                    <span><i class="fa fa-paper-plane m-0"></i></span>
                                                </CButton>
                                            </template>
                                        </CInput>
                                    </div>
                                </template>
                                <template v-if="header == 'DLS' && ML_E">
                                    <div class="d-flex justify-content-center" v-if="((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                        <CButton v-if="!data.IOL || getUserInfo.IOL" size="sm" type="submit" :class="data.HADLS ? 'btn-danger' : 'btn-success'" @click="manualTriggerDLS(data)">
                                            <span>
                                                <span>{{ getLanguage["AFF"]["ACT"] }}<i class="fa fa-power-off m-0 ml-2" aria-hidden="true"></i></span>
                                            </span>
                                            <div class="spinner-border spinner-border-sm" v-if="data.bool_sendLoading"></div>
                                        </CButton>
                                    </div>
                                    <div class="d-flex justify-content-center" v-else-if="(isSENS == 1 && data.AGI != curAGI)">
                                        <CButton v-if="!data.IOL || getUserInfo.IOL" size="sm" type="submit" :class="data.HADLS ? 'btn-danger' : 'btn-success'">
                                            <span>
                                                <span>{{ getLanguage["AFF"]["ACT"] }}<i class="fa fa-power-off m-0 ml-2" aria-hidden="true"></i></span>
                                            </span>
                                            <div class="spinner-border spinner-border-sm" v-if="data.bool_sendLoading"></div>
                                        </CButton>
                                    </div>
                                </template>

                                <template v-if="header == 'ARB' && ML_E">
                                    <div class="d-flex justify-content-center" v-if="((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                        <CButton size="sm" type="submit" :class="data.ARS != 2 ? 'btn-danger' : 'btn-success'" @click="updateStatusAutoRebate(data)">
                                            <span v-if="data.ARS == 1">
                                                <span>{{ getLanguage["GL"]["IAC"] }}<i class="fa fa-power-off m-0 ml-2" aria-hidden="true"></i></span>
                                            </span>
                                            <span v-if="data.ARS == 2">
                                                <span>{{ getLanguage["GL"]["AC"] }}<i class="fa fa-power-off m-0 ml-2" aria-hidden="true"></i></span>
                                            </span>
                                            <div class="spinner-border spinner-border-sm" v-if="data.bool_sendLoading"></div>
                                        </CButton>
                                    </div>
                                    <div class="d-flex justify-content-center" v-else-if="(isSENS == 1 && data.AGI != curAGI)">
                                        <CButton size="sm" type="submit" :class="data.ARS != 2 ? 'btn-danger' : 'btn-success'">
                                            <span v-if="data.ARS == 1">
                                                <span>{{ getLanguage["GL"]["IAC"] }}<i class="fa fa-power-off m-0 ml-2" aria-hidden="true"></i></span>
                                            </span>
                                            <span v-if="data.ARS == 2">
                                                <span>{{ getLanguage["GL"]["AC"] }}<i class="fa fa-power-off m-0 ml-2" aria-hidden="true"></i></span>
                                            </span>
                                            <div class="spinner-border spinner-border-sm" v-if="data.bool_sendLoading"></div>
                                        </CButton>
                                    </div>
                                </template>
                                <template v-if="header == 'AFF' && ML_E">
                                    <div class="d-flex justify-content-center" v-if="((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                        <CButton size="sm" type="submit" :class="data.AS != 2 ? 'btn-danger' : 'btn-success'" @click="updateStatusAffiliate(data)">
                                            <span v-if="data.AS == 1">
                                                <span>{{ getLanguage["GL"]["IAC"] }}<i class="fa fa-power-off m-0 ml-2" aria-hidden="true"></i></span>
                                            </span>
                                            <span v-if="data.AS == 2">
                                                <span>{{ getLanguage["GL"]["AC"] }}<i class="fa fa-power-off m-0 ml-2" aria-hidden="true"></i></span>
                                            </span>
                                            <div class="spinner-border spinner-border-sm" v-if="data.bool_sendLoading"></div>
                                        </CButton>
                                    </div>
                                    <div class="d-flex justify-content-center" v-else-if="(isSENS == 1 && data.AGI != curAGI)">
                                        <CButton size="sm" type="submit" :class="data.AS != 2 ? 'btn-danger' : 'btn-success'">
                                            <span v-if="data.AS == 1">
                                                <span>{{ getLanguage["GL"]["IAC"] }}<i class="fa fa-power-off m-0 ml-2" aria-hidden="true"></i></span>
                                            </span>
                                            <span v-if="data.AS == 2">
                                                <span>{{ getLanguage["GL"]["AC"] }}<i class="fa fa-power-off m-0 ml-2" aria-hidden="true"></i></span>
                                            </span>
                                            <div class="spinner-border spinner-border-sm" v-if="data.bool_sendLoading"></div>
                                        </CButton>
                                    </div>
                                </template>
                                <template v-else-if="header == 'REWARD' && MAR_E">
                                    <CButton v-if="(isSENS == 1 && data.AGI == curAGI) || isSENS == 0" size="sm" class="btn-success" @click="manualAssignReward(data)">
                                        <span>{{ getLanguage["GL"]["ASGN"] }}<i class="fa fa-paper-plane m-0 ml-2" aria-hidden="true"></i></span>
                                    </CButton>
                                </template>
                            </td>
                        </tr>
                        </tbody>

                    </table>
                </div>

                <footer style=" padding: 0.57rem 0rem;" v-if="int_TP >= 2">
                    <div class="pageBtn">
                        <div>
                            <CButton v-if="checkModuleAccess('MEPE', 'M', constAccessType.edit)" class="btnExcel" @click="saveToExcel()">
                                <img src="/Content/img/excel.png" width="20" style="padding-left:2px">
                                {{this.getLanguage["BTN"]["DL"]}}
                            </CButton>
                        </div>
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </footer>
            </div>
        </div>
        <!--</div>-->

        <div>
            <router-view>
            </router-view>
        </div>

    </div>
</template>


<script>
    import { constAccessType, constRejectReasonBL, constRejectReasonF, constTranType, consDeviceType, consTypeofmember, loadingFullScreen } from '@/modules/Constant.js'
    import DateRangePicker from 'vue2-daterange-picker'
    import Treeselect from '@riophae/vue-treeselect'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import Loading from 'vue-loading-overlay';
    import moment from "moment";
    import 'vue-loading-overlay/dist/vue-loading.css';
    import genericHelper from "@/modules/GenericHelper.js";
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import { mapGetters, mapActions } from 'vuex';
    import { required, email, sameAs, requiredIf, alphaNum, decimal, minValue, numeric } from 'vuelidate/lib/validators'
    import Vue from 'vue'
    import Sortable from 'sortablejs';
    import draggable from 'vuedraggable';
    import $ from 'jquery'
    import MemberCombineModal from "./MemberCombineModal";

    //Vue.use(require('vue-shortkey'))

    export default {
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            customtreeselect,
            Loading,
            Sortable,
            draggable,
            MemberCombineModal
        },
        data() {
            return {
                int_RC: 100, //Row Count
                int_Total: 0,
                int_Page: 1,
                int_IC: 1, // Item Count
                int_TP: 1, //Total Page
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_fingerPrintLoading: [],
                bool_Advanced: false,
                bool_AdvancedFilterAvailable: false,
                bool_showSearchBar: true,
                bool_isMobileDevice: false,

                editMemberInfo: null,
                editMemberBlock: null,
                editMemberFreeze: null,
                editMemberGame: null,

                //sensBtn: true,
                str_tableSortBy: "I", //(sort the table col name)
                bool_isSort: true, // Table Ascending Descending
                // dropdown value
                ddAgentList: null,
                ddSubAgentList: null,
                ddDefaultSubBrand: [],
                ddMemberRankList: null,
                ddEditMemberRankList: null,
                ddEditMemberTypeList: null,
                ddEditMemberCurrencyList: null,
                ddSearchMemberCurrencyList: null,
                ddSearchMemberRank: [],
                //ddSearchMemberRank:[{id:"0",label:"No Rank"},{id:"1",label:"Rank 1"},{id:"2",label:"Rank 2"},{id:"3",label:"Rank 3"},{id:"4",label:"Rank 4"},{id:"5",label:"Rank 5"}],
                ddEditMemberReferralList: null,
                ddMemberStatusList: null,
                ddBankBrandList: null,
                ddEditBankBrandList: null,
                ddDepositedList: null,
                ddToDepositList: null,
                ddCreditBalanceList: null,
                ddMemberList: [],
                ddMarketerListFS: [],
                ddMarketerList: [],
                ddDefaultMarketerList: null,
                ddTypeName: null,
                // search fields
                searchAgi: null,
                searchSAgi: null,
                searchCurrency: null,
                searchAgent: null,
                searchSubAgent: null,
                searchMemberRank: null,
                searchUsername: null,
                searchMarketer: null,
                searchDisplayName: null,
                searchRegisterSourceName: null,
                searchDomainName: null,
                searchIP: null,
                searchBirthday: { startDate: null, endDate: null },
                searchMemberStatus: 2,
                searchReferralUN: null,
                searchReferralCode: null,
                searchRegisterDtRange: { startDate: "", endDate: "" },
                searchLDepositDtRange: { startDate: "", endDate: "" },
                searchLPromoDtRange: { startDate: "", endDate: "" },
                searchLPlayedDtRange: { startDate: "", endDate: "" },
                searchPhone: null,
                searchEmail: null,
                searchWeChat: null,
                searchLine: null,
                searchBank: null,
                searchBankAccName: null,
                searchBankAcc: null,
                searchTWG: 1,
                searchPKVU: null,
                searchDeposited: null,
                searchToDeposit: null,
                searchCreditBalance: null,
                searchCIP: null,
                searchDevice: null,
                searchTypeofmember: null,
                searchTypeName: null,
                arr_MemberList: [],
                obj_member: {},
                editBirthday: { startDate: null, endDate: null },

                bool_isMemberListAdvancedSearchModalVisible: false,
                bool_memberCV: false,
                bool_barCV: false,
                bool_rewardCV: false,
                bool_haveRef: false,
                bool_isTopup: false,
                IsMember: 0,
                dummyInt: 0,
                constAccessType: constAccessType,
                noData: true,
                regexInt: new RegExp("^[0-9]+$"),
                regexDecimal: new RegExp("^[0-9]+[\.]?[0-9]*$"),
                needResetHeaders: false,
                defaultReportHeaders: ['NO', 'ACT', 'AGT', 'ACC', 'CIP', 'LFPI', 'LLTS_LLIP', 'LDTS', 'PTTS', 'CBL', 'MEMMW', 'MEMPW', 'D', 'TW', 'BA', 'RSN', 'BR', 'MRI', 'LLD', 'DEV', 'MKT', 'DA', 'WA', 'DLS', 'ARB', 'AFF', 'REWARD'],
                reportHeaders: [],
                opened: [],
                arry_visitorMembers: {},
                arry_systemId: {},
                ML_A: false,
                ML_E: false,
                ML_D: false,
                MBA_A: false,
                MAR_E: false,
                MCMI_V: false,
                HideContactInfo: false,
                EditContactInfo: false,
                HideBankInfo: false,
                EditBankInfo: false,
                searchExactRegIP: true,
                searchExactLastLogInIP: true,
                bool_isBAR: false,
                bool_isReward: false,
                isSubAgent: false,
                arr_FV: {
                    "AGI": null,
                },
                obj_ad:
                {
                    AGI: null,
                    SAGAGI: null,
                    MI: null,
                    R: "",
                    RS: 2,
                    IMA: 1,
                    TT: null,
                    AC: 1,
                    TA: "",
                    BB: "",
                    CI: null
                },
                dd_tranType: [],
                dd_deviceType: [],
                dd_typeofmember: [],
                CurrencySymbol: "",
                requestBrand: "",
                requestUsername: "",
                bool_cacheOptionValue: true,
                bool_cacheMarketerOptionValue: true,
                requestDA: [],
                requestWA: [],
                requestDLS: [],

                //SubAgent / Outlet
                bool_isDepositV: false,
                obj_OutletTran: [],
                obj_OutletTran2: [],
                obj_ManualPromo: {
                    "AGI": 0,
                    "CNT": "",
                    "CNM": "",
                    "R": [],
                },
                bool_EnableAffiliate: false,
                ddDefaultMemberList: [],
                rtAffiliateKey: 0,
                rtSubBrand: 0,
                dd_promotion: [],
                rtPromoKey: 0,
                strTnxConfirm: "",
                bool_isWithdraw: false,
                //////////
                bool_EBAIN: false,
                str_invalidNumericMsg: "",

                ddTransferWalletOptions: null,
                selectedFile: null,
                selectedQRCode: null,
                previewUrl: null,
                bool_fullPreview: false,
                bool_isDDMV: false,
                searchExcludeSubAgent: false,

                str_afterSaveOutlet_URL: "",
                bool_OutletAfterSave: false,
                bool_checkCopy: false,
                hasTransLoading: false,

                HideCryptoAccountInfo: false,
                EditCryptoAccountInfo: false,
                dd_RewardList: [],
                obj_Reward:
                {
                    MI: null,
                    PRI: null
                },
            }
        },
        methods: {
            ...mapActions('UserInfo', ['setSearchCriteriaAGI']),
            ...mapActions('CurrencyInfo', ['setThousandCurrency']),

            CurrencyChange(value) {
                this.setThousandCurrency(this.CheckIsThousandCurrency(value, this), this);
            },
            DateTimeChange(type, event) {
                if (type == "RSD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.searchRegisterDtRange.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.searchRegisterDtRange.startDate = "";
                    }
                }
                if (type == "RED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.searchRegisterDtRange.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.searchRegisterDtRange.endDate = "";
                    }
                }
                if (type == "DSD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.searchLDepositDtRange.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.searchLDepositDtRange.startDate = "";
                    }
                }
                if (type == "DED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.searchLDepositDtRange.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.searchLDepositDtRange.endDate = "";
                    }
                }
                if (type == "LPSD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.searchLPlayedDtRange.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.searchLPlayedDtRange.startDate = "";
                    }
                }
                if (type == "LPED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.searchLPlayedDtRange.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.searchLPlayedDtRange.endDate = "";
                    }
                }
                if (type == "BD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.searchBirthday.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.searchBirthday.startDate = "";
                    }
                }
            },
            TextValueChange(type, event) {
                if (type == "RJ") {
                    this.obj_ad.R = event.target.value;
                }
            },
            CheckingMember(agi, mi) {
                let routeData = this.$router.resolve({ path: '/M/ML/CheckingMember', query: { agi: agi, i: mi } });
                window.open(routeData.href, '_blank');
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('ML', 'M', type);
            },
            checkModuleAccess3(type) {
                return this.checkModuleAccess('BLL', 'M', type);
            },
            getbgtooltip(data) {
                var bgColor = '#FFF';
                var textColor = '#000';
                if (data) {
                    if (data.MTBC) {
                        bgColor = data.MTBC;
                    }

                    if (data.MTC) {
                        textColor = data.MTC;
                    }
                }
                return {
                    backgroundColor: bgColor, color: textColor, padding: '0px 5px', borderRadius: '5px'
                };
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                this.getMemberList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            getCurrentRoute() {
                return this.$route.path;
            },
            onFileSelected(event) {
                this.selectedFile = this.validateFile(event, 0.2, [".jpg", ".jpeg", ".bmp", ".gif", ".png", ".webp"]);
            },
            copyMemberDetails() {
                let textToCopy = '';
                if (this.str_afterSaveOutlet_URL) {
                    textToCopy = `${this.getLanguage["MEM"]["U"]}: ${this.obj_member.U}\n${this.getLanguage["MEM"]["UP"]}: ${this.obj_member.UP}\n${this.getLanguage["WLBP"]["W"]}: https://${this.str_afterSaveOutlet_URL}`;

                } else {
                    textToCopy = `${this.getLanguage["MEM"]["U"]}: ${this.obj_member.U}\n${this.getLanguage["MEM"]["UP"]}: ${this.obj_member.UP}\n`;
                }
                const textarea = document.createElement('textarea');
                textarea.value = textToCopy;
                textarea.setAttribute('readonly', '');
                textarea.style.position = 'absolute';
                textarea.style.left = '-9999px';
                document.body.appendChild(textarea);

                textarea.select();
                document.execCommand('copy');
                this.bool_checkCopy = true;

                document.body.removeChild(textarea);
            },
            CloseOutletAfterSave() {
                this.bool_OutletAfterSave = false;
                this.bool_checkCopy = false;
            },

            renderLoginDetails(data, isToolTipsText) {
                if (typeof data.LB === 'string' && data.LB != "") {
                    data.LB = JSON.parse(data.LB);
                }
                if ((data.IM == 1 || data.IM == 2 || data.IM == 3) && data.LB != null && isToolTipsText == 0) {
                    var details = "";
                    if ((data.LB.Browser != "Unknown") || (data.LB.Browser != "unknown")) {
                        details += data.LB.Browser;
                    }
                    if ((data.LB.MobileDevice != "Unknown") || (data.LB.MobileDevice != "unknown")) {
                        details += " " + data.LB.MobileDevice;
                    }
                    else if ((data.LB.MobileDeviceManufacturer != "Unknown") || (data.LB.MobileDeviceManufacturer != "unknown")) {
                        details += " " + data.LB.MobileDeviceManufacturer;
                    }
                    return details;
                }
                else if (data.IM == 0 && data.LB != null && isToolTipsText == 0) {
                    return data.LB.Browser;
                }
                else if (data.LB != null && isToolTipsText == 1) {
                    return data.LB.UserAgent;
                }
                return "-";
            },
            getDevice(data) {
                var status = '';
                if (data == 1) {
                    status = this.getLanguage['DEV']['M'];
                }
                else if (data == 2) {
                    status = this.getLanguage['DEV']['A'];
                }
                else if (data == 3) {
                    status = this.getLanguage['DEV']['IOS'];
                }
                else {
                    status = this.getLanguage['DEV']['D'];
                }

                return status;
            },
            TickCheckbox(event, data) {
                var val = 0;
                if (event.target.checked) {
                    val = 1;
                }

                data.SV = val;
            },

            showadvModals() {
                this.bool_isMemberListAdvancedSearchModalVisible = !this.bool_isMemberListAdvancedSearchModalVisible;
            },
            closeDeposit() {
                this.bool_isDepositV = !this.bool_isDepositV;
            },
            closeRequest() {
                this.bool_isBAR = !this.bool_isBAR;
                this.bool_barCV = false;
            },
            closeReward() {
                this.bool_isReward = !this.bool_isReward;
                this.bool_rewardCV = false;
            },
            closeTopUp() {
                this.bool_isTopup = !this.bool_isTopup;
            },
            getAgentGroup() {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {
                            that.ddAgentList = that.deepClone(d.dropdownlist);

                            if (that.ddAgentList.length > 0) {
                                that.ddAgentList.forEach(that.disableAgentGroupParent);
                            }
                        }
                    });
            },
            disableAgentGroupParent(item, index) {
                var agi = item.id.split("-");
                //if (agi[0] != "3") {
                //    item.isDisabled = true;
                //}

                if (parseInt(agi[0]) < 3) {
                    item.isDisabled = true;
                }

                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.disableAgentGroupParent);
                }
            },
            checkIpAddress(ip) {
                if (ip) {
                    return `https://whatismyipaddress.com/ip/${ip}`;
                    //return `https://whatismyipaddress.com/ip/${ip}`;
                }
                else {
                    return '#';
                }
            },
            loadAgentOptions({ action, callback, instanceId }) {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddAgentList = d.dropdownlist;
                        }
                        else {
                            that.ddAgentList = [];
                        }
                        callback(null, that.ddAgentList);
                    });
            },
            loadMemberOptions({ action, searchQuery, callback }) {
                var that = this;
                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddMemberList = [];
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/mreferral/0/${searchQuery}/${this.searchAgi}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddMemberList = d.dropdownlist;
                                //that.bool_cacheOptionValue = true;
                            }
                            else {
                                that.ddMemberList = [];
                            }

                            callback(null, that.ddMemberList);
                        });
                }
            },
            loadAvailableReferralOptions({ action, searchQuery, callback }) {
                var that = this;
                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddMemberList = [];
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/areferral/${searchQuery}/${this.searchAgi}/${this.obj_member.I}/${this.obj_member.CI}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddMemberList = d.dropdownlist;
                                //that.bool_cacheOptionValue = true;
                            }
                            else {
                                that.ddMemberList = [];
                            }

                            callback(null, that.ddMemberList);
                        });
                }
            },
            loadMarketerOptionsFS({ action, searchQuery, callback }) {
                var that = this;
                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddMarketerListFS = [];
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/marketer/0/${searchQuery}/${this.searchAgi}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddMarketerListFS = d.dropdownlist;
                            }
                            else {
                                that.ddMarketerListFS = [];
                            }

                            callback(null, that.ddMarketerListFS);
                        });
                }
            },
            loadSubBrandOptions({ action, searchQuery, callback }) {
                var that = this;
                var parentAGI = 0;

                if (this.obj_member && this.obj_member.f_AGI && this.bool_isAMV) {
                    var agentList = this.obj_member.f_AGI.id.split("-");
                    parentAGI = agentList[agentList.length - 1];
                }
                else if (this.searchAgent && !this.bool_isAMV) {
                    var agentList = this.searchAgent.split("-");
                    parentAGI = agentList[agentList.length - 1];
                }
                else if (this.getUserInfo.AT === 4) {
                    parentAGI = 0;
                }
                else {
                    this.ddSubAgentList = [];
                    callback(this.getLanguage['MEM']['PSAA']);
                }

                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddSubAgentList = [];
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${parentAGI}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddSubAgentList = d.dropdownlist;
                                //that.bool_cacheOptionValue = true;
                                if (that.getUserInfo.AT === 4)
                                    that.SubAgentGroupChange(parentAGI);
                            }
                            else {
                                that.ddSubAgentList = [];
                            }
                            callback(null, that.ddSubAgentList);
                        });
                }
            },
            loadDefaultSubBrand(agi, isFirstLoad = false) {
                var that = this;
                var searchQuery = "0";

                this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${agi}`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddDefaultSubBrand = that.deepClone(d.dropdownlist);
                            if (isFirstLoad) {
                                that.searchSubAgent = that.ddDefaultSubBrand[0].id;
                                that.rtSubBrand = that.rtSubBrand == 0 ? 1 : 0;
                                that.getMemberList();
                            }
                        }
                    });
            },

            AgentGroupChangefs(value) {
                this.ddSearchMemberCurrencyList = null;
                this.searchSubAgent = null;
                if (value) {
                    this.setSearchCriteriaAGI(value);
                    var agi = 0;
                    if (value != "") {
                        agi = value.split("-")[1];
                    }
                    this.searchAgi = agi;
                    this.searchPAgi = agi;
                }
                else {
                    this.setSearchCriteriaAGI(null);
                    this.searchAgi = 0;
                    this.searchPAgi = 0;
                }
                this.ddMemberRankList = null;
                this.searchMemberRank = null;
                this.ddBankBrandList = null;
                this.searchBank = null;
                this.bool_cacheMarketerOptionValue = false;
                this.bool_cacheOptionValue = false;

            },
            SubAgentGroupChangefs(value) {
                if (value) {
                    this.setSearchCriteriaAGI(value);
                    var agi = 0;
                    if (value != "") {
                        agi = value;
                    }
                    this.searchAgi = agi;
                }
                else {
                    this.setSearchCriteriaAGI(null);
                    this.searchAgi = 0;
                }
                this.ddMemberRankList = null;
                this.searchMemberRank = null;
                this.ddBankBrandList = null;
                this.searchBank = null;
                this.bool_cacheOptionValue = false;
                this.ddTypeName = null;
                this.searchTypeName = null;
                this.ddSearchMemberCurrencyList = null;
            },
            selectEditReferralOptions(value, instanceId) {
                this.obj_member.RI = this.obj_member.f_RI;
                this.obj_member.RU = '';
                if (this.obj_member.RI) {
                    for (var i = 0; i < this.ddEditMemberReferralList.length; i++) {
                        if (this.ddEditMemberReferralList[i].id == this.obj_member.RI) {
                            this.obj_member.RU = this.ddEditMemberReferralList[i].label;
                            break;
                        }
                    }
                }
            },
            loadMemberRankOptions({ action, callback, instanceId }) {
                var that = this;
                if (!this.searchAgent) {
                    callback(this.getLanguage['MEM']['PSAA']);
                }
                else {
                    var agentList = this.searchAgent.split("-");
                    this.getDataApi(`/api/dd/mr/${agentList[agentList.length - 1]}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddMemberRankList = d.dropdownlist;
                            }
                            else {
                                that.ddMemberRankList = null;
                            }

                            callback();
                        });
                }
            },
            loadSearchMemberCurrencyOptions({ action, callback, instanceId }) {
                var that = this;

                if (!this.searchPAgi) {
                    this.searchPAgi = 0;
                }

                this.getDataApi(`/api/dd/cur/${this.searchPAgi}`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddSearchMemberCurrencyList = d.dropdownlist;
                        }
                        else {
                            that.ddSearchMemberCurrencyList = null;
                        }
                        callback();
                    });
            },

            getCurrencyList() {
                var that = this;
                var agi = 0;

                if (this.searchAgent) {
                    var agentList = this.searchAgent.split("-");
                    agi = agentList[1];
                }

                this.getDataApi(`/api/dd/currency/${agi}`,
                    function (d, s) {
                        if (s) {
                            that.ddSearchMemberCurrencyList = d.dropdownlist;
                        }
                    });
            },
            loadBankBrandOptions({ action, callback, instanceId }) {
                var that = this;
                this.getDataApi(`/api/dd/allbank`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddBankBrandList = d.dropdownlist;
                        }
                        else {
                            that.ddBankBrandList = null;
                        }
                        callback();
                    });

            },
            loadTDepositOptions({ action, callback, instanceId }) {
                var that = this;
                this.getDataApi(`/api/dd/tdeposit`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddToDepositList = d.dropdownlist;
                        }
                        else {
                            that.ddToDepositList = null;
                        }

                        callback();
                    });
            },
            loadCreditBalanceOptions({ action, callback, instanceId }) {
                var that = this;
                this.getDataApi(`/api/dd/tcreditbal`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddCreditBalanceList = d.dropdownlist;
                        }
                        else {
                            that.ddCreditBalanceList = null;
                        }

                        callback();
                    });
            },
            getCreditBalanceOptions() {
                var that = this;
                this.getDataApi(`/api/dd/tcreditbal`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddCreditBalanceList = d.dropdownlist;
                        }
                        else {
                            that.ddCreditBalanceList = null;
                        }

                        //callback();
                    });
            },
            ctrPage(newPage, inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getMemberList();
            },
            newSearch() {
                if (!this.bool_isAMV && !this.bool_isMemberListAdvancedSearchModalVisible && !this.bool_isMemberBlacklistDetailV && !this.bool_isMemberFreezeDetailV) {
                    this.$refs.search.focus();
                    this.int_Page = 1;
                    this.int_IC = 1;
                    this.getBasicMemberList();
                }
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            getAdvancedMemberList() {
                this.bool_Advanced = true;
                this.checkAdvanceSearchStatus();
                this.getMemberList();
            },
            getBasicMemberList() {
                this.bool_Advanced = false;
                this.getMemberList();
            },
            getMemberList() {
                this.bool_fullLoading = true;
                this.bool_fullScreen = false;
                var that = this;
                var agentGId = null;

                if (this.searchAgent) {
                    var agentList = this.searchAgent.split("-");
                    agentGId = agentList[agentList.length - 1];
                }

                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);
                var hasDefaultPath = false;

                if (path) {
                    hasDefaultPath = true;
                }

                //if (agentGId) {
                //    path += "&f.AGI=" + agentGId;
                //}
                if (this.searchSubAgent) {
                    path += "&f.AGI=" + this.searchSubAgent;
                } else if (agentGId) {
                    path += "&f.AGI=" + agentGId;
                }

                if (this.searchUsername) {
                    path += "&f.MI=" + this.searchUsername;
                }

                if (this.searchMarketer) {
                    path += "&f.AI=" + this.searchMarketer;
                }

                if (this.searchDisplayName) {
                    path += "&f.N=" + this.searchDisplayName;
                }

                if (this.searchIP) {
                    path += "&f.LLIP=" + this.searchIP;
                }

                if (this.searchCIP) {
                    path += "&f.CIP=" + this.searchCIP;
                }
                if (this.searchCurrency) {
                    path += "&f.CI=" + this.searchCurrency;
                }

                if (this.searchRegisterDtRange) {
                    if (this.searchRegisterDtRange.startDate != "") {
                        path += "&f.CTS_from=" + this.parseDateToJsonString(this.searchRegisterDtRange.startDate);
                    }

                    if (this.searchRegisterDtRange.endDate != "") {
                        path += "&f.CTS_to=" + this.parseDateToJsonString(this.searchRegisterDtRange.endDate);
                    }
                }

                if (this.searchBankAcc) {
                    path += "&f.BANUM=" + this.searchBankAcc;
                }
                if (this.searchMemberRank) {
                    path += "&f.MRI=" + this.searchMemberRank;
                }

                if (this.searchPKVU) {
                    path += "&f.PKVU=" + this.searchPKVU;
                    if (this.searchTWG) {
                        path += "&f.TWG=" + this.searchTWG;
                    } else {
                        path += "&f.TWG=1";
                        this.searchTWG = 1;
                    }
                }

                if (this.searchCreditBalance) {
                    path += "&f.CBL=" + this.searchCreditBalance;
                }

                if (!this.searchSubAgent) {
                    path += "&f.EXSAG=" + this.searchExcludeSubAgent;
                }

                if (this.bool_Advanced) {
                    this.bool_fullScreen = true;
                    if (this.searchBirthday) {
                        if (this.searchBirthday.startDate) {
                            path += "&f.B=" + this.parseDateToJsonString(this.searchBirthday.startDate);
                        }
                    }

                    if (this.searchMemberStatus) {
                        path += "&f.R=" + this.searchMemberStatus;
                    }

                    if (this.searchTypeName) {
                        var encodedSearchTypeName = encodeURIComponent(this.searchTypeName);
                        path += `&f.TN=${encodedSearchTypeName}`;
                    }

                    if (this.searchReferralUN) {
                        path += "&f.RU=" + this.searchReferralUN;
                    }

                    if (this.searchRegisterSourceName) {
                        path += "&f.RSN=" + this.searchRegisterSourceName;
                    }

                    if (this.searchReferralCode) {
                        path += "&f.RFC=" + this.searchReferralCode.trim();
                    }

                    if (this.searchDomainName) {
                        path += "&f.SDN=" + this.searchDomainName;
                    }

                    if (this.searchLDepositDtRange) {
                        if (this.searchLDepositDtRange.startDate != "") {
                            path += "&f.LDTS_from=" + this.parseDateToJsonString(this.searchLDepositDtRange.startDate);
                        }

                        if (this.searchLDepositDtRange.endDate != "") {
                            path += "&f.LDTS_to=" + this.parseDateToJsonString(this.searchLDepositDtRange.endDate);
                        }
                    }

                    if (this.searchLPlayedDtRange) {
                        if (this.searchLPlayedDtRange.startDate != "") {
                            path += "&f.LPTS_from=" + this.parseDateToJsonString(this.searchLPlayedDtRange.startDate);
                        }

                        if (this.searchLPlayedDtRange.endDate != "") {
                            path += "&f.LPTS_to=" + this.parseDateToJsonString(this.searchLPlayedDtRange.endDate);
                        }
                    }

                    if (this.searchPhone) {
                        path += "&f.PN=" + this.searchPhone;
                    }

                    if (this.searchEmail) {
                        path += "&f.E=" + this.searchEmail;
                    }

                    if (this.searchWeChat) {
                        path += "&f.WC=" + this.searchWeChat;
                    }

                    if (this.searchLine) {
                        path += "&f.LID=" + this.searchLine;
                    }

                    if (this.searchBank) {
                        path += "&f.BS=" + this.searchBank;
                    }

                    if (this.searchBankAccName) {
                        path += "&f.BAN=" + this.searchBankAccName;
                    }

                    if (this.searchDeposited) {
                        path += "&f.D=" + this.searchDeposited;
                    }

                    if (this.searchToDeposit) {
                        path += "&f.TD=" + this.searchToDeposit;
                    }
                    if (this.searchCreditBalance) {
                        path += "&f.CBL=" + this.searchCreditBalance;
                    }
                    if (this.searchDevice) {
                        path += "&f.IM=" + this.searchDevice;
                    }
                    if (this.searchTypeofmember) {
                        path += "&f.TOM=" + this.searchTypeofmember;
                    }
                }
                else {
                    //path += "&f.R=2";
                }

                if (!hasDefaultPath && path) {
                    path = path.substring(1);
                }

                if (this.searchExactRegIP) {
                    path += "&f.ERIP=" + this.searchExactRegIP;
                }

                if (this.searchExactLastLogInIP) {
                    path += "&f.ELLIP=" + this.searchExactLastLogInIP;
                }

                this.getDataApi(`/api/m/l?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        that.bool_fullScreen = false;
                        if (s) {
                            that.bool_isMemberListAdvancedSearchModalVisible = false;
                            that.int_TP = Math.max(d.D.TotalPages, 1);
                            that.int_Total = d.D.TotalItems;
                            that.arr_MemberList = d.D.Items;
                            that.resizeTableHead();

                            if (d.D && d.D.Items && d.D.Items.length > 0) {
                                that.isSubAgent = d.D.Items[0].ISA;
                            }
                        }
                    });
            },
            unBlockMemberBank(d, AGI, MI) {
                this.$fire({
                    title: this.getLanguage["MEM"]["CUBA"],
                    html: this.HideInfo(this.HideBankInfo, d.BA, 4) + " (" + d.BNM + ") - " + this.HideInfo(this.HideBankInfo, d.BAN, 4),
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        var dt = {
                            MI: MI,
                            BAN: d.BAN,
                            AGI: AGI
                        };

                        this.postDataApi(`/api/m/ubmba`, dt,
                            function (d, s) {
                                that.bool_fullLoading = false;

                                if (s) {
                                    that.getMemberList();
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                    }
                });
            },
            ValidationAdjustmentErrMsg(value, langKey = "") {
                if (this.bool_barCV) {
                    var validateObj = this.$v.obj_ad[value];
                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["MTA"][langKey]);
                    }
                    else if (validateObj.decimal != undefined && !validateObj.decimal) {
                        return String.format(this.utilGetErrorLanguage('1007'), this.getLanguage["MTA"][langKey]);
                    }
                    else if (validateObj.minValueValue != undefined && !validateObj.minValueValue) {
                        return String.format(this.utilGetErrorLanguage('4442'), this.getLanguage["MTA"][langKey]);
                    }
                }
            },
            ValidationRewardErrMsg(value, langKey = "") {
                if (this.bool_rewardCV) {
                    var validateObj = this.$v.obj_Reward[value];
                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["MEM"][langKey]);
                    }
                }
            },
            clearDateRangeFilter(value) {
                if (value == 'searchBirthday') {
                    this.searchBirthday = {
                        startDate: null,
                        endDate: null
                    };
                }
                else if (value == 'searchRegisterDtRange') {
                    this.searchRegisterDtRange = {
                        startDate: "",
                        endDate: ""
                    };
                }
                else if (value == 'searchLDepositDtRange') {
                    this.searchLDepositDtRange = {
                        startDate: "",
                        endDate: ""
                    };
                }
                else if (value == 'searchLPlayedDtRange') {
                    this.searchLPlayedDtRange = {
                        startDate: "",
                        endDate: ""
                    };
                }
            },
            ReturnMemberRank(RN, CNN, KHN, IDN, KRN, MYN, THN, VNN, ION) {
                var langcode = this.getLangCode;
                switch (langcode) {
                    case "en":
                        return RN;
                        break;
                    case "cn":
                        return CNN;
                        break;
                    case "kh":
                        return KHN;
                        break;
                    case "id":
                        return IDN;
                        break;
                    case "kr":
                        return KRN;
                        break;
                    case "my":
                        return MYN;
                        break;
                    case "th":
                        return THN;
                        break;
                    case "vn":
                        return VNN;
                        break;
                    case "io":
                        return ION;
                        break;

                }
                return langcode;

            },
            resetColumn(headerName) {
                var that = this;
                for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                    that.$set(that.reportHeaders, i, that.defaultReportHeaders[i])
                }
                this.resizeTableHead();
            },
            removeColumn(headerName) {
                var that = this;
                const index = that.reportHeaders.indexOf(headerName);
                if (index > -1)
                    that.reportHeaders.splice(index, 1);
                that.resizeTableHead();
            },
            removeDefaultColumn(headerName) {
                var that = this;
                const index = that.defaultReportHeaders.indexOf(headerName);
                if (index > -1)
                    that.defaultReportHeaders.splice(index, 1);
                this.resizeTableHead();
            },
            toggleFingPrintId(data, member_id) {
                var that = this;
                var path = this.getListingParamQuery(1, 50, this.str_tableSortBy, this.bool_isSort);

                path += "&f[MI]=" + member_id;
                path += "&f[FPJI]=" + data.SI;
                path += "&f[AGI]=" + data.AGI;

                const index = that.opened.indexOf(data.UBI + '_' + data.SI);

                if (index > -1) {
                    that.opened.splice(index, 1)

                } else {
                    this.getDataApi(`/api/m/gsiu/?${path}`,
                        function (d, s) {
                            if (s) {
                                that.arry_visitorMembers[data.UBI + '_' + data.SI] = d.D.Items;
                                that.opened.push(data.UBI + '_' + data.SI)
                            }
                        });
                }
            },
            getSystemId(data) {
                var that = this;
                var path = this.getListingParamQuery(1, 50, this.str_tableSortBy, this.bool_isSort);

                path += "&f[MI]=" + data.I;

                const index = that.opened.indexOf(data.I);

                if (index > -1) {
                    that.opened.splice(index, 1)

                } else {
                    this.getDataApi(`/api/m/gsi/?${path}`,
                        function (d, s) {
                            if (s) {
                                that.arry_systemId[String(data.I)] = d.D.Items;
                                that.opened.push(data.I)
                            }
                        });
                }
                this.resizeTableHead();
            },
            renderActionType(int_status) {
                switch (int_status) {
                    case 2:
                        return 'Login';
                        break;
                    default:
                        return 'Register';
                        break;
                }
            },
            registerIP() {
                if (this.searchExactRegIP) {
                    this.searchExactRegIP = false;
                } else {
                    this.searchExactRegIP = true;
                }
            },
            lastLoginIP() {
                if (this.searchExactLastLogInIP) {
                    this.searchExactLastLogInIP = false;
                } else {
                    this.searchExactLastLogInIP = true;
                }
            },
            newRequest(d) {
                this.bool_barCV = false;
                this.bool_fullLoading = true;
                this.obj_ad =
                {
                    AGI: d.AGI,
                    MI: d.I,
                    R: "",
                    RS: 2,
                    TT: null,
                    AC: 1,
                    TA: "",
                    CI: d.CI
                };

                this.requestBrand = d.AGN;
                this.requestUsername = d.U;
                this.CurrencySymbol = d.CS;
                this.CurrencyChange(d.CS);
                this.bool_isBAR = true;
                this.bool_fullLoading = false;
            },
            saveRequest(ccp) {
                this.bool_barCV = true;

                //if (this.obj_ad.AGIT != null && this.obj_ad.AGIT.length > 0) {
                //    var agi = this.obj_ad.AGIT.split("-");
                //    this.obj_ad.AGI = agi[1];
                //}

                //  this.obj_ad["RURL"] = this.selectedFile;
                this.obj_ad['AC'] = 1;   // Apply
                this.obj_ad['ASRT'] = "::[MTA][BARST]::";   // this.getLanguage["MTA"]["BARST"];
                this.obj_ad['ASRM'] = "::[MTA][BARSM]::";   // this.getLanguage["MTA"]["BARSM"];
                if (ccp) {
                    this.obj_ad["CCP"] = 1;
                    this.obj_ad["CCPR"] = this.getLanguage["PM"]["H2PCCPR"];
                }
                else {
                    this.obj_ad["CCP"] = 0;
                    this.obj_ad["CCPR"] = '';
                }

                this.$v.obj_ad.$touch();
                if (!this.$v.obj_ad.$error) {

                    this.$fire({
                        title: this.getLanguage["MTA"]["CA"],
                        width: '30em',
                        showCancelButton: true,
                        confirmButtonText: this.getLanguage["GL"]["YES"],
                        cancelButtonText: this.getLanguage["CNO"]["NO"],
                        reverseButtons: true,
                        customClass: {
                            title: 'afb-alert-title',
                            content: 'afb-alert-content',
                            actions: 'afb-alert-action'
                        }
                    }).then((result) => {
                        if (result.value == true) {
                            var that = this;
                            this.bool_fullLoading = true;
                            this.bool_fullScreen = true;
                            //this.postDataApiWithAttach(`/api/baladj/ap`, this.obj_ad,
                            this.postDataApi(`/api/baladj/ap`, this.obj_ad,
                                function (d, s) {
                                    that.bool_fullLoading = false;
                                    that.bool_fullScreen = false;
                                    if (s && d.ERR && d.ERR.length > 0 && d.ERR[0].ERRC == 6090) {
                                        that.$fire({
                                            // title: this.getLanguage["MTA"]["CA"],
                                            html: that.utilGetErrorLanguage(d.ERR[0].ERRC),
                                            width: '30em',
                                            showCancelButton: true,
                                            confirmButtonText: 'OK',
                                            cancelButtonText: that.getLanguage["GL"]["CANCEL"],
                                            reverseButtons: true,
                                            customClass: {
                                                title: 'afb-alert-title',
                                                content: 'afb-alert-content',
                                                actions: 'afb-alert-action'
                                            }
                                        }).then((confirmRes) => {
                                            if (confirmRes.value == true) {
                                                that.saveRequest(1);
                                            }
                                        });
                                    }
                                    else if (s) {
                                        that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                        that.bool_isBAR = false;
                                        that.getMemberList();
                                    }
                                });
                        }
                    });
                }
            },
            saveToExcel() {
                var agentGId = null;
                if (this.searchAgent) {
                    var agentList = this.searchAgent.split("-");
                    agentGId = agentList[agentList.length - 1];
                }

                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);
                var hasDefaultPath = false;

                if (path) {
                    hasDefaultPath = true;
                }

                if (this.searchSubAgent) {
                    path += "&f.AGI=" + this.searchSubAgent;
                } else if (agentGId) {
                    path += "&f.AGI=" + agentGId;
                }

                if (this.searchUsername) {
                    path += "&f.MI=" + this.searchUsername;
                }

                if (this.searchMarketer) {
                    path += "&f.AI=" + this.searchMarketer;
                }

                if (this.searchDisplayName) {
                    path += "&f.N=" + this.searchDisplayName;
                }

                if (this.searchIP) {
                    path += "&f.LLIP=" + this.searchIP;
                }

                if (this.searchCIP) {
                    path += "&f.CIP=" + this.searchCIP;
                }
                if (this.searchCurrency) {
                    path += "&f.CI=" + this.searchCurrency;
                }

                if (this.searchRegisterDtRange) {
                    if (this.searchRegisterDtRange.startDate != "") {
                        path += "&f.CTS_from=" + this.parseDateToJsonString(this.searchRegisterDtRange.startDate);
                    }

                    if (this.searchRegisterDtRange.endDate != "") {
                        path += "&f.CTS_to=" + this.parseDateToJsonString(this.searchRegisterDtRange.endDate);
                    }
                }

                if (this.searchBankAcc) {
                    path += "&f.BANUM=" + this.searchBankAcc;
                }

                if (this.searchPKVU) {
                    path += "&f.PKVU=" + this.searchPKVU;
                    if (this.searchTWG) {
                        path += "&f.TWG=" + this.searchTWG;
                    } else {
                        path += "&f.TWG=1";
                        this.searchTWG = 1;
                    }
                }
                if (!this.searchSubAgent) {
                    path += "&f.EXSAG=" + this.searchExcludeSubAgent;
                }
                if (this.bool_Advanced) {
                    if (this.searchBirthday) {
                        if (this.searchBirthday.startDate) {
                            path += "&f.B=" + this.parseDateToJsonString(this.searchBirthday.startDate);
                        }
                    }

                    if (this.searchMemberRank) {
                        path += "&f.MRI=" + this.searchMemberRank;
                    }

                    if (this.searchMemberStatus) {
                        path += "&f.R=" + this.searchMemberStatus;
                    }

                    if (this.searchTypeName) {
                        path += "&f.TN=" + this.searchTypeName;
                    }

                    if (this.searchReferralUN) {
                        path += "&f.RU=" + this.searchReferralUN;
                    }

                    if (this.searchRegisterSourceName) {
                        path += "&f.RSN=" + this.searchRegisterSourceName;
                    }

                    if (this.searchReferralCode) {
                        path += "&f.RFC=" + this.searchReferralCode;
                    }

                    if (this.searchDomainName) {
                        path += "&f.SDN=" + this.searchDomainName;
                    }

                    if (this.searchLDepositDtRange) {
                        if (this.searchLDepositDtRange.startDate != "") {
                            path += "&f.LDTS_from=" + this.parseDateToJsonString(this.searchLDepositDtRange.startDate);
                        }

                        if (this.searchLDepositDtRange.endDate != "") {
                            path += "&f.LDTS_to=" + this.parseDateToJsonString(this.searchLDepositDtRange.endDate);
                        }
                    }

                    if (this.searchLPlayedDtRange) {
                        if (this.searchLPlayedDtRange.startDate != "") {
                            path += "&f.LPTS_from=" + this.parseDateToJsonString(this.searchLPlayedDtRange.startDate);
                        }

                        if (this.searchLPlayedDtRange.endDate != "") {
                            path += "&f.LPTS_to=" + this.parseDateToJsonString(this.searchLPlayedDtRange.endDate);
                        }
                    }

                    if (this.searchPhone) {
                        path += "&f.PN=" + this.searchPhone;
                    }

                    if (this.searchEmail) {
                        path += "&f.E=" + this.searchEmail;
                    }

                    if (this.searchWeChat) {
                        path += "&f.WC=" + this.searchWeChat;
                    }

                    if (this.searchLine) {
                        path += "&f.LID=" + this.searchLine;
                    }

                    if (this.searchBank) {
                        path += "&f.BS=" + this.searchBank;
                    }

                    if (this.searchBankAccName) {
                        path += "&f.BAN=" + this.searchBankAccName;
                    }

                    if (this.searchDeposited) {
                        path += "&f.D=" + this.searchDeposited;
                    }

                    if (this.searchToDeposit) {
                        path += "&f.TD=" + this.searchToDeposit;
                    }
                    if (this.searchCreditBalance) {
                        path += "&f.CBL=" + this.searchCreditBalance;
                    }
                    if (this.searchDevice) {
                        path += "&f.IM=" + this.searchDevice;
                    }
                    if (this.searchTypeofmember) {
                        path += "&f.TOM=" + this.searchTypeofmember;
                    }
                }
                else {
                    //path += "&f.R=2";
                }

                if (!hasDefaultPath && path) {
                    path = path.substring(1);
                }

                if (this.searchExactRegIP) {
                    path += "&f.ERIP=" + this.searchExactRegIP;
                }

                if (this.searchExactLastLogInIP) {
                    path += "&f.ELLIP=" + this.searchExactLastLogInIP;
                }

                window.open('/api/m/exportexcel?' + path, '_blank');

            },
            loadTypeNameOptions({ action, callback, instanceId }) {
                var that = this;
                this.getDataApi(`/api/dd/mtname`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddTypeName = d.dropdownlist;
                        }
                        else {
                            that.ddTypeName = null;
                        }
                        callback();
                    });

            },
            transactionShortcut(memData, tranType) {
                // tranType: 1 = deposit, 2 = withdraw
                var actionLang;
                var tranAmt;
                this.obj_OutletTran = [];

                if (memData.I > 0 && ((memData.depositAmt > 0 && tranType == '1') || (memData.withdrawAmt > 0 && tranType == '2'))) {
                    this.getPromotionDDList(memData.AGI, memData.I, memData.CI, memData.depositAmt, memData.IOL);

                    //Populate data
                    this.obj_OutletTran['AGI'] = memData.AGI;
                    this.obj_OutletTran['MI'] = memData.I;

                    if (tranType == '1') {  //deposit
                        actionLang = this.getLanguage["TD"]["TT1"];
                        tranAmt = this.formatNumber(memData.depositAmt, 2, memData.CS);
                        this.obj_OutletTran['TA'] = memData.depositAmt;
                        this.bool_isWithdraw = false;
                    }
                    else if (tranType == '2') {  //withdraw
                        actionLang = this.getLanguage["TD"]["TT2"];
                        tranAmt = this.formatNumber(memData.withdrawAmt, 2, memData.CS);
                        this.obj_OutletTran['TA'] = memData.withdrawAmt;
                        this.bool_isWithdraw = true;
                    }

                    this.strTnxConfirm = memData.U + " " + actionLang + " " + tranAmt;
                    this.bool_isDepositV = !this.bool_isDepositV;
                }
            },
            getPromotionDDList(agi, memberId, currencyId, depositAmt, isOutlet) {
                var that = this;
                this.getDataApi(`/api/dd/dptpromo/` + agi + `/` + memberId,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.dd_promotion = d.dropdownlist;
                            that.rtPromoKey = that.rtPromoKey == 0 ? 1 : 0;
                        }
                        else {
                            that.dd_promotion = [];
                        }
                    });
                //this.getDataApi(`/api/dd/gapromo/${agi}/${memberId}/${currencyId}/${depositAmt}/${isOutlet}`,
                //    function (d, s) {
                //        if (s && d && d.dropdownlist) {
                //            that.dd_promotion = d.dropdownlist;
                //            that.rtPromoKey = that.rtPromoKey == 0 ? 1 : 0;
                //        }
                //        else {
                //            that.dd_promotion = [];
                //        }
                //    });
            },
            processTransaction() {
                // tranType: 1 = deposit, 2 = withdraw
                var that = this;

                if (that.hasTransLoading) return;

                that.bool_fullLoading = true;
                that.bool_fullScreen = true;
                that.hasTransLoading = true;

                if (this.obj_OutletTran['MI'] > 0) {
                    //common value for manual deposit/withdraw transaction
                    this.obj_OutletTran['AC'] = 2;
                    this.obj_OutletTran['CCP'] = 0;
                    this.obj_OutletTran['IMA'] = 1;
                    this.obj_OutletTran['PM'] = 3;
                    this.obj_OutletTran['RS'] = 2;
                    this.obj_OutletTran['TM'] = 1;

                    if (!this.bool_isWithdraw) {  //deposit
                        this.obj_OutletTran['DSRM'] = "::[MTA][DSM]::";
                        this.obj_OutletTran['DSRT'] = "::[MTA][DST]::";
                        this.obj_OutletTran['TT'] = "1";
                        this.obj_OutletTran["RURL"] = this.selectedFile;
                    }
                    else if (this.bool_isWithdraw) {  //withdraw
                        this.obj_OutletTran['WSRT'] = "::[MTA][WST]::";
                        this.obj_OutletTran['WSRM'] = "::[MTA][WSM]::";
                        this.obj_OutletTran['IITO'] = 1;
                        this.obj_OutletTran['TT'] = "2";
                    }
                    else {
                        that.bool_fullLoading = false;
                        that.bool_fullScreen = false;
                        that.hasTransLoading = false;
                        return;
                    }

                    this.postDataApiWithAttach(`/api/memtrans/ap`, this.obj_OutletTran,
                        function (d, s) {
                            if (s) {

                                if (that.obj_OutletTran['PI'] > 0) {
                                    that.processManualPromo();
                                } else {
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                    that.getMemberList();
                                }
                                that.bool_fullLoading = false;
                                that.bool_fullScreen = false;
                                that.hasTransLoading = false;
                                that.bool_isDepositV = false;
                            }
                            that.bool_fullLoading = false;
                            that.bool_fullScreen = false;
                            that.hasTransLoading = false;
                            that.bool_isDepositV = false;
                        });
                }

                //if (this.obj_OutletTran2['MI'] > 0) {
                //    //common value for manual deposit/withdraw transaction
                //    this.obj_OutletTran2['AC'] = 2;
                //    this.obj_OutletTran2['CCP'] = 0;
                //    this.obj_OutletTran2['IMA'] = 1;
                //    this.obj_OutletTran2['PM'] = 3;
                //    this.obj_OutletTran2['RS'] = 2;
                //    this.obj_OutletTran2['TM'] = 1;

                //    if (!this.bool_isWithdraw) {  //deposit
                //        this.obj_OutletTran2['DSRM'] = "::[MTA][DSM]::";
                //        this.obj_OutletTran2['DSRT'] = "::[MTA][DST]::";
                //        this.obj_OutletTran2['TT'] = "1";
                //        this.obj_OutletTran2["RURL"] = this.selectedFile;
                //    }
                //    else if (this.bool_isWithdraw) {  //withdraw
                //        this.obj_OutletTran2['WSRT'] = "::[MTA][WST]::";
                //        this.obj_OutletTran2['WSRM'] = "::[MTA][WSM]::";
                //        this.obj_OutletTran2['IITO'] = 1;
                //        this.obj_OutletTran2['TT'] = "2";
                //    } else return;

                //    that.bool_fullLoading = true;

                //    this.postDataApiWithAttach(`/api/memtrans/ap`, this.obj_OutletTran2,
                //        function (d, s) {
                //            if (s) {

                //                if (that.obj_OutletTran2['PI'] > 0) {
                //                    that.processManualPromo();
                //                } else {
                //                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                //                    that.getMemberList();
                //                }
                //                that.bool_isTopup = !that.bool_isTopup;
                //            }
                //            that.bool_fullLoading = false;
                //        });
                //}
            },
            processManualPromo() {
                var that = this;

                if (this.obj_OutletTran['PI'] > 0) {

                    this.obj_ManualPromo.R.push({
                        "MI": this.obj_OutletTran['MI'],
                        "PI": this.obj_OutletTran['PI']
                    })

                    this.obj_ManualPromo['AGI'] = this.obj_OutletTran['AGI'];
                    this.obj_ManualPromo['CNT'] = "::[PM][PST]::";
                    this.obj_ManualPromo['CNM'] = "::[PM][PSM]::";
                }

                this.postDataApi(`/api/mpromo/mapv2`, this.obj_ManualPromo,
                    function (d, s) {
                        if (s) {
                            if (d != null && d.D != null && d.D.Items != null && d.D.Items.length > 0 && !d.D.Items[0].S) {
                                that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("DEPOSIT.DSRT") + " " + that.processMessage(d.D.Items[0].R));
                            }
                            else {
                                that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                            }
                        }
                        else {
                            that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("DEPOSIT.DSRT") + " " + that.utilGetErrorLanguage("PM.PRT"));
                        }
                        that.obj_OutletTran['PI'] = null;
                        that.obj_ManualPromo = {
                            "AGI": 0,
                            "CNT": "",
                            "CNM": "",
                            "R": [],
                        };
                        that.getMemberList();
                    });
            },
            processMessage(_errArr) {
                let temp = '';
                let msg = '';

                for (var i = 0; i < _errArr.length; i++) {
                    if (_errArr[i].ERRC && _errArr[i].CL && _errArr[i].CL.length > 0) {
                        var arr_args = this.splitColumnName(_errArr[i].CL);
                        var targs = [];
                        targs.push(this.utilGetErrorLanguage(_errArr[i].ERRC));
                        for (var j = 0; j < arr_args.length; j++) {
                            targs.push(arr_args[j]);
                        }

                        temp = String.format.apply(null, targs);
                    }
                    else if (_errArr[i].ERRC) {
                        temp = this.utilGetErrorLanguage(_errArr[i].ERRC);
                    }
                    else if (_errArr[i].CL && _errArr[i].CL.length > 0) {
                        if (_errArr[i].CL.length == 1)
                            temp = this.utilGetErrorLanguage(_errArr[i].CL[0]);
                        else {
                            var arr_ags = this.splitColumnName(_errArr[i].CL);
                            temp = arr_ags.join("\n\n");
                        }
                    }

                    msg += temp + "\n\n";
                }

                return msg;
            },
            manualTriggerDLS(memData) {

                if (memData.I <= 0)
                    return;

                this.$fire({
                    title: this.getLanguage["MTA"]["CADLS"],
                    html: this.getLanguage["AFF"]["ACT"] + " > " + memData.U,
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        var dt = {
                            I: memData.I,
                            SAGI: memData.SAGI,
                            IOL: memData.IOL
                        };

                        this.postDataApi(`/api/sag/smdls`, dt,
                            function (d, s) {
                                that.bool_fullLoading = false;

                                if (s) {
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                    that.getMemberList();
                                }
                            });
                    }
                });
            },
            updateStatusAutoRebate(memData) {

                if (memData.I <= 0)
                    return;

                this.$fire({
                    title: memData.ARS == 2 ? this.getLanguage["MEM"]["CDAB"] : this.getLanguage["MEM"]["CAAB"],
                    html: memData.ARS == 2 ? this.getLanguage["MEM"]["DAC"] + " > " + memData.U : this.getLanguage["AFF"]["ACT"] + " > " + memData.U,
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {

                        var status = memData.ARS == 2 ? 1 : 2;
                        this.bool_fullLoading = true;
                        var that = this;
                        var dt = {
                            I: memData.I,
                            SAGI: memData.SAGI,
                            ARS: status
                        };

                        this.postDataApi(`/api/sag/smars`, dt,
                            function (d, s) {
                                that.bool_fullLoading = false;

                                if (s) {
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                    that.getMemberList();
                                }
                            });
                    }
                });
            },
            updateStatusAffiliate(memData) {

                if (memData.I <= 0)
                    return;

                this.$fire({
                    title: memData.AS == 2 ? this.getLanguage["MEM"]["CDAFF"] : this.getLanguage["MEM"]["CAAFF"],
                    html: memData.AS == 2 ? this.getLanguage["MEM"]["DAC"] + " > " + memData.U : this.getLanguage["AFF"]["ACT"] + " > " + memData.U,
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {

                        var status = memData.AS == 2 ? 1 : 2;
                        this.bool_fullLoading = true;
                        var that = this;
                        var dt = {
                            I: memData.I,
                            SAGI: memData.SAGI,
                            AS: status
                        };

                        this.postDataApi(`/api/sag/smas`, dt,
                            function (d, s) {
                                that.bool_fullLoading = false;

                                if (s) {
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                    that.getMemberList();
                                }
                            });
                    }
                });
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    bodyCells.forEach((cell, index) => {
                        if (!headerCells[index]) return;  // Add a safety check to avoid undefined errors

                        const headerWidth = headerCells[index].getBoundingClientRect().width;
                        const bodyWidth = cell.getBoundingClientRect().width;
                        const width = `${Math.max(bodyWidth, headerWidth)}px`;

                        headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
            setPreview(newImg, oldImg) {
                this.previewUrl = newImg ? URL.createObjectURL(newImg) : oldImg;
                this.bool_fullPreview = true;
            },
            closeAdd1() {
                this.previewUrl = null;
                this.bool_fullPreview = !this.bool_fullPreview;
            },
            renderClassName(header, data) {
                if (header == 'ACC') {
                    return "kema-eft";
                } else if (header == 'LDTS' || header == 'PTTS' || header == 'MEMMW' || header == 'MEMPW' || header == 'CBL' || header == 'D' || header == 'TW') {
                    return "tableCtnRight";
                }
            },
            getMemberRank() {
                this.ddSearchMemberRank = [
                    { id: "0", label: this.getLanguage['MEM']['NR'] }, // 硬编码的第一项
                    ...Array.from({ length: 10 }, (_, index) => ({
                        id: (index + 1).toString(), // 动态生成 id (1 到 5)
                        label: `${this.getLanguage['MEM']['R']} ${index + 1}` // 动态生成 label
                    }))
                ];
            },
            getDeviceType() {
                this.dd_deviceType = [{ id: "", label: this.getLanguage['GL']['ALL2'] }, { id: "0", label: this.getLanguage['DEV']['D'] },
                { id: "1", label: this.getLanguage['DEV']['M'] }, { id: "2", label: this.getLanguage['DEV']['A'] },
                { id: "3", label: this.getLanguage['DEV']['IOS'] }];
            },
            getTypeOfMember() {
                this.dd_typeofmember = [{ id: "0", label: this.getLanguage['MEM']['RRB'] }, { id: "1", label: this.getLanguage['MTA']['PVP'] }, { id: "2", label: this.getLanguage['MTA']['MNM'] }];
            },
            renderBlackListReason(blackListReason) {
                const found = constRejectReasonBL.some(el => el.id === blackListReason);

                if (found) {
                    for (var d of constRejectReasonBL) {
                        if (d.id == blackListReason) {
                            blackListReason = d.label;
                        }
                    }
                }

                return blackListReason;
            },
            unBlacklistMember(d) {
                this.$fire({
                    title: this.getLanguage["MEM"]["CUBLK"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        var dt = {
                            i: d.I,
                            uts: d.UTS,
                            agi: d.AGI,
                            CI: d.CI,
                            U: d.U
                        };

                        this.postDataApi(`/api/m/ubm`, dt,
                            function (d, s) {
                                that.bool_fullLoading = false;

                                if (s) {
                                    that.getMemberList();
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                    }
                });
            },
            unFreezeMember(d) {
                this.$fire({
                    title: this.getLanguage["MEM"]["CUF"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        var dt = {
                            i: d.I,
                            uts: d.UTS,
                            agi: d.AGI
                        };

                        this.postDataApi(`/api/m/ufm`, dt,
                            function (d, s) {
                                that.bool_fullLoading = false;

                                if (s) {
                                    that.getMemberList();
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                    }
                });
            },
            manualAssignReward(data) {
                this.bool_barCV = false;
                this.bool_fullLoading = true;
                this.obj_Reward =
                {
                    brand: data.AGN,
                    username: data.U,
                    currency: data.CS,
                    MI: data.I,
                    PRI: null
                };
                this.dd_RewardList = [];
                var that = this;
                this.getDataApi(`/api/dd/rwdl/${data.AGI}/${data.CI}`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.dd_RewardList = d.dropdownlist;
                            if (d.dropdownlist && d.dropdownlist.length > 0) {
                                var dt = {
                                    MI: data.I,
                                    PRI: d.dropdownlist[0].id
                                };
                            }
                        }
                        that.bool_fullLoading = false;
                    });
                this.bool_isReward = true;
                this.bool_fullLoading = false;
            },
            saveManualReward() {
                this.bool_rewardCV = true;
                this.$v.obj_Reward.$touch();
                if (!this.$v.obj_Reward.$error) {
                    this.bool_fullLoading = true;
                    var that = this;
                    that.postDataApi(`/api/preward/mar`, this.obj_Reward,
                        function (d, s) {
                            if (s) {
                                that.showSuccessMessage(that.utilGetErrorLanguage("SMB.MAR") + " " + that.utilGetErrorLanguage("ERR.SS"));
                                that.bool_rewardCV = false;
                                that.bool_isReward = false;
                            }
                            that.bool_fullLoading = false;
                        });
                }
            },
            editMember(d) {
                this.editMemberInfo = d;
            },
            editMemberGameSetting(d) {
                this.editMemberGame = d;
            },
            blacklistMember(d) {
                this.editMemberBlock = d;
            },
            freezeMember(d) {
                this.editMemberFreeze = d;
            },
            checkAdvanceSearchStatus() {
                var hasValue = (
                    this.searchBirthday && this.searchBirthday.startDate ||
                    this.searchMemberStatus ||
                    this.searchTypeName ||
                    this.searchReferralUN ||
                    this.searchRegisterSourceName ||
                    (this.searchReferralCode && this.searchReferralCode.trim()) ||
                    this.searchDomainName ||
                    this.searchLDepositDtRange && this.searchLDepositDtRange.startDate ||
                    this.searchLDepositDtRange && this.searchLDepositDtRange.endDate ||
                    this.searchLPlayedDtRange && this.searchLPlayedDtRange.startDate ||
                    this.searchLPlayedDtRange && this.searchLPlayedDtRange.endDate ||
                    this.searchPhone ||
                    this.searchEmail ||
                    this.searchWeChat ||
                    this.searchLine ||
                    this.searchBank ||
                    this.searchBankAccName ||
                    this.searchDeposited ||
                    this.searchToDeposit ||
                    this.searchCreditBalance ||
                    this.searchDevice ||
                    this.searchTypeofmember
                );
                if (hasValue) {
                    this.bool_AdvancedFilterAvailable = true;
                } else {
                    this.bool_AdvancedFilterAvailable = false;
                }
            },
            clearAdvanceSearchFields() {
                this.searchBirthday = { startDate: "", endDate: "" };
                this.searchMemberStatus = null;
                this.searchTypeName = null;
                this.searchReferralUN = null;
                this.searchRegisterSourceName = null;
                this.searchReferralCode = null;
                this.searchDomainName = null;
                this.searchLDepositDtRange = { startDate: "", endDate: "" };
                this.searchLPlayedDtRange = { startDate: "", endDate: "" };
                this.searchPhone = null;
                this.searchEmail = null;
                this.searchWeChat = null;
                this.searchLine = null;
                this.searchBank = null;
                this.searchBankAccName = null;
                this.searchDeposited = null;
                this.searchToDeposit = null;
                this.searchCreditBalance = null;
                this.searchDevice = null;
                this.searchTypeofmember = null;
                this.checkAdvanceSearchStatus();
            },
            showAccessFailedMessage() {
                if (!this.MCMI_V) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.TI"), this.utilGetErrorLanguage("MEM.DHMCMI_V"));
                }
            }
        },
        validations: {
            obj_ad: {
                TT: { required },
                R: { required },
                TA: { required, decimal, minValueValue: minValue(0) }
            },
            obj_Reward: {
                PRI: { required }
            },
        },
        computed: {
            ...mapGetters('Language', ['getLanguage', 'getLangCode']),
            ...mapGetters('UserInfo', ['getUserInfo', 'checkModuleAccess', 'getUserMemberSC']),
            ...mapGetters('CurrencyInfo', ['getThousandCurrency']),
            selectedAgent: {
                get() {

                    if (this.ddAgentList && this.ddAgentList.length === 1) {
                        let currentItem = this.ddAgentList[0];

                        while (currentItem.children && Array.isArray(currentItem.children)) {
                            if (currentItem.children.length === 1) {
                                currentItem = currentItem.children[0];
                            } else if (currentItem.children.length > 1) {
                                return this.searchAgent;
                            } else {
                                return currentItem.id;
                            }
                        }
                        return currentItem.id;
                    }
                    return this.searchAgent;
                },
                set(value) {
                    this.searchAgent = value;
                    this.getCurrencyList();
                }
            },
        },
        watch: {
            bool_isBAR() {
                if (!this.bool_isBAR && this.bool_barCV) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
                }
            },
            bool_isReward() {
                if (!this.bool_isReward && this.bool_rewardCV) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
                }
            },
            getLanguage() {
                //this.getMemberTypeList();
                this.getMemberRank();
                this.getDeviceType();
                this.getTypeOfMember();
                this.getCurrencyList();
                this.getMemberList();
            },
            reportHeaders() {
                var that = this;
                if (this.reportHeaders == null) {
                    this.getDataApi(`/api/reports/gc/MemberList`,
                        function (d, s) {
                            if (s) {
                                if (d == null) {
                                    that.reportHeaders = [];
                                    for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                                        if (that.reportHeaders.indexOf(that.defaultReportHeaders[i]) == -1)
                                            that.reportHeaders.push(that.defaultReportHeaders[i]);
                                    }
                                }
                                else {
                                    try {
                                        that.reportHeaders = JSON.parse(d);
                                    } catch (e) {
                                        d += "]";
                                        that.reportHeaders = JSON.parse(d);
                                    }
                                }

                                //Sub agent have manual deposit & withdrawal & dls(outlet) shortcut in member list
                                if (that.getUserInfo.AT !== 4) {
                                    //Deposit
                                    that.removeDefaultColumn('DA')
                                    that.removeColumn('DA')

                                    //Withdrawal
                                    that.removeDefaultColumn('WA')
                                    that.removeColumn('WA')

                                    //Auto rebate
                                    that.removeDefaultColumn('ARB')
                                    that.removeColumn('ARB')

                                    //Affiliate
                                    that.removeDefaultColumn('AFF')
                                    that.removeColumn('AFF')
                                }
                                else {  //Sub Agent also need to check for role access
                                    if (!that.checkModuleAccess('MD', 'D', constAccessType.add)) {
                                        that.removeDefaultColumn('DA')
                                        that.removeColumn('DA')
                                    }

                                    if (!that.checkModuleAccess('MW', 'W', constAccessType.add)) {
                                        that.removeDefaultColumn('WA')
                                        that.removeColumn('WA')
                                    }
                                }

                                ////Ticket 8083: Only Agent/Sub agent/Sub agent oulet have manual trigger dls
                                if (that.getUserInfo.AT == 0 || that.getUserInfo.AT == 1 || that.getUserInfo.AT == 2) {
                                    //DLS
                                    that.removeDefaultColumn('DLS')
                                    that.removeColumn('DLS')
                                }
                                else {
                                    if (!that.checkModuleAccess('DLSS', 'P', constAccessType.view)) {
                                        that.removeDefaultColumn('DLS')
                                        that.removeColumn('DLS')
                                    }
                                }

                                // check special permission to allow manual assign reward
                                if (!that.MAR_E) {
                                    that.removeDefaultColumn('REWARD')
                                    that.removeColumn('REWARD')
                                }

                                // hide columns for unauthorized access users
                                if (!(that.ML_E || that.ML_D)) {
                                    that.removeDefaultColumn('ACT')
                                    that.removeColumn('ACT')

                                    //Auto rebate
                                    that.removeDefaultColumn('ARB')
                                    that.removeColumn('ARB')

                                    //Affiliate
                                    that.removeDefaultColumn('AFF')
                                    that.removeColumn('AFF')
                                }

                                //Only outlet mobile will hide these column
                                if (that.isOUTMOB) {
                                    var elements = [];
                                    that.defaultReportHeaders.forEach((element, index) => {
                                        if (element != 'NO' && element != 'ACT' && element != 'MEMMW' && element != 'ACC' && element != 'DA' && element != 'WA') elements.push(element);
                                    });
                                    that.defaultReportHeaders = _.difference(that.defaultReportHeaders, elements);

                                    var element2s = [];
                                    that.reportHeaders.forEach((element, index) => {
                                        if (element != 'NO' && element != 'ACT' && element != 'MEMMW' && element != 'ACC' && element != 'DA' && element != 'WA') element2s.push(element);
                                    });
                                    that.reportHeaders = _.difference(that.reportHeaders, element2s);
                                }
                            }
                        });
                }
                else {
                    this.getDataApi(`/api/reports/sc/MemberList/` + JSON.stringify(that.reportHeaders),
                        function (d, s) {
                            if (s) {

                            }
                        });
                }


                if (this.reportHeaders != null) {
                    if (that.defaultReportHeaders.length != that.reportHeaders.length)
                        that.needResetHeaders = true;
                    else {
                        that.needResetHeaders = false;
                    }
                }
            },
            searchUsername() {
                this.bool_cacheOptionValue = true;
            },
            searchMarketer() {
                this.bool_cacheMarketerOptionValue = true;
            },
        },
        created() {

            this.$parent.showSubMenu = 'M';
            this.$parent.showActiveMenu = 'M.ML';
            if (this.getUserInfo.AT == 4) {
                this.getAgentGroup();
            }
            this.searchAgi = this.$route.query.agi;
            this.searchCurrency = this.$route.query.ci;
            this.searchCreditBalance = this.$route.query.cb;
            this.ML_A = this.checkModuleAccess('ML', 'M', constAccessType.add);
            this.ML_E = this.checkModuleAccess('ML', 'M', constAccessType.edit);
            this.ML_D = this.checkModuleAccess('ML', 'M', constAccessType.delete);
            this.MBA_A = this.checkModuleAccess('MBA', 'M', constAccessType.add);
            this.MAR_E = this.checkModuleAccess('MAR', 'M', constAccessType.edit);
            this.MCMI_V = this.checkModuleAccess('MCMI', 'M', constAccessType.view);
            //this.MCMI_E = this.checkModuleAccess('MCMI', 'M', constAccessType.edit);

            this.HideContactInfo = this.getUserInfo.IHMI_C;
            this.EditContactInfo = !this.getUserInfo.IHMI_C && this.checkModuleAccess('VEC', 'M', constAccessType.edit);
            this.HideBankInfo = this.getUserInfo.IHMI;
            this.EditBankInfo = !this.getUserInfo.IHMI && this.checkModuleAccess('VEB', 'M', constAccessType.edit);
            this.HideCryptoAccountInfo = this.getUserInfo.IHMI;
            this.EditCryptoAccountInfo = !this.getUserInfo.IHMI && this.checkModuleAccess('VEB', 'M', constAccessType.edit);

            this.reportHeaders = null;

            if (this.$route.query.df) {
                this.searchLDepositDtRange.startDate = this.$route.query.df;
                this.bool_Advanced = true;
            }
            if (this.$route.query.dt) {
                this.searchLDepositDtRange.endDate = this.$route.query.dt;
                this.bool_Advanced = true;
            }
            if (this.$route.query.dRf) {
                this.searchRegisterDtRange.startDate = this.$route.query.dRf;
                this.bool_Advanced = true;
                this.searchMemberStatus = null;
            }
            if (this.$route.query.dRt) {
                this.searchRegisterDtRange.endDate = this.$route.query.dRt;
                this.bool_Advanced = true;
            }
            if (this.searchAgi) {
                if (this.$route.query.agType == 4) {
                    this.searchAgent = '4-' + this.searchAgi;
                    this.loadDefaultSubBrand(this.searchAgi, true);
                }
                else {
                    this.searchAgent = '3-' + this.searchAgi;
                    this.getMemberList();
                }

            }
            else {
                if (this.getUserInfo.AT == 4) {
                    this.loadDefaultSubBrand(0, true);
                }
                else {
                    this.getMemberList();
                }
            }
            this.getMemberRank();
            this.getCurrencyList();
            this.getCreditBalanceOptions();
            this.ddMemberStatusList = [{ id: '2', label: this.getLanguage['GL']['AC'] }, { id: '1', label: this.getLanguage['GL']['BLK'] }];
            this.ddDepositedList = [{ id: 'true', label: this.getLanguage['GL']['YES'] }, { id: 'false', label: this.getLanguage['GL']['NO'] }];
            this.onOffOptionList = [{ id: '', label: '' }, { id: '0', label: this.getLanguage['GS']['OFF'] }, { id: '1', label: this.getLanguage['GS']['ON'] }];
            this.ddTransferWalletOptions = [{ id: 1, label: 'PKV' }, { id: 2, label: 'Mega888' }, { id: 3, label: 'Pussy888' }, { id: 4, label: '918Kiss' }];

            this.dd_tranType = constTranType;
            this.bool_isMobileDevice = this.getUserInfo.IMD && this.getUserInfo.AT == 4;
            this.getDeviceType();
            this.getTypeOfMember();
            this.isSENS = this.getUserInfo.ISENS;
            this.isOUTMOB = (localStorage.getItem('isOutletMobile') == 'True') ? true : false;
            this.curAGI = this.getUserInfo.AGI;
            this.checkAdvanceSearchStatus();
        }

    }
</script>

<style scoped>
    .breadcrumb-item + .font-xl.breadcrumb-item::before {
        color: rgb(140, 195, 38);
        content: '>>';
        padding: 0px 10px;
    }

    .c-sidebar-nav-lin {
        white-space: normal;
    }

    .btn-outline-primary:hover svg {
        fill: #fff !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/Member/MemberList.vue